import type { Dict } from "../i18n";

export const ptBR: Dict = {
  "common.close": "Fechar",
  "boot.errorTitle": "Não foi possível abrir o jogo",
  "boot.webglHint": "O navegador não conseguiu iniciar os gráficos 3D. Tente abrir em um navegador atualizado com aceleração gráfica disponível.",
  "boot.errorHint": "Tente abrir o jogo novamente. Se a falha continuar, envie os detalhes abaixo ao suporte.",
  "boot.retry": "Tentar novamente",
  "boot.details": "Detalhes da falha",
  "game.title": "VOID HUNTER",
  "game.slogan": "Cace. Absorva. Ascenda.",

  "menu.play": "Jogar",
  "menu.resume": "Continuar",
  "menu.settings": "Configurações",
  "menu.language": "Idioma",
  "menu.back": "Voltar",
  "menu.restart": "Reiniciar",
  "menu.ranking": "🏆 Ranking",
  "menu.site": "Site oficial",
  "pvp.interact": "⚔️ Arena PvP",

  "hud.level": "Nível",
  "hud.health": "Vida",
  "hud.experience": "Experiência",
  "hud.dash": "DASH",
  "hud.essence": "Essência",

  "combat.critical": "CRÍTICO",
  "combat.blocked": "BLOQUEIO",
  "area.complete": "ÁREA CONCLUÍDA — o portão abriu",
  "rift.lockedChampions": "🔒 Faltam {n} × {quem} — em {onde}",
  "area.locked": "Portão trancado · falta {n}",
  "area.goal.territories": "explorar territórios",
  "area.goal.champions": "derrotar campeões",
  "area.goal.kills": "abater monstros",
  "area.goal.chests": "abrir baús",
  "area.goal.boss": "derrotar o boss",
  "area.goal.boss.voidAlpha": "derrotar o Apex Fang",
  "area.goal.boss.aetherColossus": "derrotar o Aether Colossus",
  "area.goal.boss.guardian": "derrotar o Guardião da área",
  "region.unlockedNext": "NOVA REGIÃO LIBERADA — {name} (Nv {n}+) · viaje pelo Portal Rift ou pelo Mapa",
  "depth.new": "PROFUNDIDADE {n} — o mundo voltou mais forte",
  "depth.treePoints": "🌳 +{n} pontos da Árvore do Void",
  "depth.label": "Profundidade {n}",
  "depth.intro.title": "Profundidade {n} — o mundo virou de novo!",
  "depth.intro.territories": "🗺️ Todos os territórios e missões de área voltam a pedir reconquista (abates, campeão, baú de novo).",
  "depth.intro.chests": "📦 Os baús do mundo reabrem — dá pra saquear tudo outra vez.",
  "depth.intro.harder": "🔒 As portas entre territórios pedem um nível um pouco mais alto que na volta passada.",
  "depth.intro.tree": "🌳 Você ganhou +{n} pontos pra gastar na Árvore do Void.",
  "combat.weak": "FRACO!",
  "combat.resisted": "resistiu",
  "combat.weakTo": "Fraco a",
  "combat.tough": "Aguenta",
  "player.levelUp": "SUBIU DE NÍVEL",

  "game.paused": "PAUSADO",
  "game.youDied": "VOCÊ MORREU",
  "game.respawning": "Renascendo em {s}s...",
  "ads.revive": "📺 Reviver aqui (50% vida, sem perder item)",
  "ads.reviveVip": "👑 Reviver aqui (VIP · sem anúncio)",
  "ads.reviveNote": "Restam {n} hoje",
  "ads.revived": "✨ Você reviveu no mesmo lugar!",
  "ads.dailyDouble": "📺 Coletar em DOBRO",
  "ads.dailyDoubleVip": "👑 Coletar em DOBRO",
  "ads.freeDiamonds": "📺 +{n} 💎 grátis ({left} hoje)",
  "ads.xpBoost": "📺 +50% XP por 15 min ({left} hoje)",
  "ads.sectionTitle": "Grátis assistindo",
  "ads.vipHint": "VIP recebe tudo isto sem assistir anúncio.",
  "ads.notRewarded": "Anúncio pulado — sem recompensa.",

  "settings.title": "Configurações",
  "settings.language": "Idioma",
  "settings.controls": "Controles",
  "settings.resetProgress": "Zerar Progresso",
  "settings.resetConfirm": "Apagar TODO o progresso (nível, essência, upgrades)? Não dá pra desfazer.",
  "settings.resetYes": "Apagar",
  "settings.resetNo": "Cancelar",

  "controls.move": "Mover",
  "controls.attack": "Atacar",
  "controls.hook": "Gancho",
  "controls.dash": "Dash",
  "controls.pause": "Pausar",
  "controls.interact": "Interagir",
  "controls.stick": "Joystick",
  "controls.sprint": "Correr / reposicionar",
  "controls.auto": "Automático",
  "controls.devHint": "Dev: WASD · Botão Dir gancho · Espaço correr · E · Esc (ataque é automático)",

  "hint.start": "Joystick p/ mover · ataque é automático · botões GANCHO e CORRER",

  "essence.power": "Poder",
  "essence.vitality": "Vitalidade",
  "essence.agility": "Agilidade",
  "essence.fortitude": "Fortitude",
  "essence.ferocity": "Ferocidade",
  "essence.title": "Essências",
  "essence.collected": "+{n} {name}",

  "enemy.voidling": "Shardling",
  "enemy.voidSpitter": "Cuspidor do Vazio",
  "enemy.voidHusk": "Casca Oca",
  "enemy.shardCrawler": "Rastejante de Lascas",
  "enemy.veinLurker": "Espreitador do Veio",
  "enemy.stormLance": "Lança de Tempestade",
  "enemy.ruinSentinel": "Sentinela da Ruína",
  "enemy.voidWisp": "Void Wisp",
  "enemy.voidRunner": "Riftclaw",
  "enemy.voidBrute": "Stoneback",

  "hook.ready": "Gancho pronto",
  "hook.cooldown": "Gancho recarregando",

  "altar.name": "ALTAR DO VOID",
  "altar.title": "Altar do Void",
  "altar.interact": "Interagir",
  "altar.cost": "Custo",
  "altar.level": "Nv {n}",
  "altar.insufficient": "Essência insuficiente",
  "altar.close": "Fechar",
  "altar.effect.power": "+{n} de Dano",
  "altar.effect.vitality": "+{n} HP Máx",
  "altar.effect.agility": "+{n}% Velocidade",
  "altar.effect.fortitude": "+{n} de Armadura",
  "altar.effect.ferocity": "+{n}% Chance Crítica",

  "enemy.corruptedBrute": "Rift Warden",

  "boss.voidKing": "Rei do Vazio",
  "boss.voidAlpha": "APEX FANG",
  "boss.riftSeer": "RIFT SEER",
  "boss.defeated": "APEX FANG DERROTADO",
  "boss.phaseRage": "FÚRIA DO VOID",
  "boss.interrupt": "INTERROMPIDO!",

  "region.forestEntrance": "Entrada da Floresta",
  "region.voidClearing": "Clareira do Void",
  "region.corruptedGrove": "Bosque Corrompido",
  "region.alphaDen": "Covil do Alpha",
  "region.pathOpened": "O caminho para o Covil do Alpha foi aberto.",

  "interaction.challengeBoss": "Desafiar o Apex Fang",
  "reward.alphaSoul": "Alma do Apex adquirida",
  "elite.progress": "Elite abatido — {n}/{total}",
  "boss.awakens": "O APEX FANG DESPERTA",
  "boss.fury": "🔥 FÚRIA — o boss bate mais forte!",
  "boss.leashWarn": "⚠️ Você saiu da arena — o boss desiste em {s} s",
  "boss.leashReset": "O boss perdeu você de vista e voltou ao covil. Volte pra desafiar de novo.",
  "event.bossAwakens": "BOSS DE EVENTO — UMA FENDA SE ABRE!",
  "event.bossDefeated": "Boss de Evento derrotado — arma exclusiva!",
  "areaBoss.awakens": "O GUARDIÃO DA ÁREA DESPERTA!",
  "guardian.label": "👑 Guardião · {n}/{need} abates",
  "bossZone.sealed": "🔒 A porta se trancou! Só sai vencendo… ou caindo.",
  "bossZone.noFlee": "🔒 Na Fenda não há pra onde correr — vença ou caia!",
  "world.flee": "🏳️ Fugir da luta",
  "world.fleeSub": "desiste do boss e volta ao Santuário",
  "world.fled": "Você fugiu da luta. O boss vai esperar você voltar.",
  "guardian.ready": "👑 GUARDIÃO DESPERTO — entre na arena",
  "guardian.awakened": "👑 O Guardião despertou na Arena — vá até lá pra enfrentá-lo!",
  "guardian.challenge": "👑 Enfrentar o Guardião",
  "guardian.progress": "👑 Guardião: {n}/{need} abates",
  "areaBoss.defeated": "Guardião da Área derrotado!",

  // 10.9AC — Invasão do Vazio (evento de 4h)
  "worldEvent.start": "⚠️ INVASÃO DO VAZIO! Mate os corrompidos pra ganhar poder e liberar o boss!",
  "worldEvent.progress": "Corrompidos até o boss: {left}",
  "worldEvent.bossReady": "O BOSS FOI LIBERADO — encare-o!",
  "worldEvent.bossAwakens": "{name} desperta! (renascimento {tier})",
  "worldEvent.bossDown": "Boss abatido! Ele renascerá mais forte — mate mais corrompidos.",
  "worldEvent.end": "A Invasão do Vazio terminou. Os poderes temporários se foram.",
  "worldEvent.boss.wrath": "Alfa da Ira",
  "worldEvent.boss.frost": "Alfa Gélido",
  "worldEvent.boss.plague": "Alfa da Praga",
  "worldEvent.boss.storm": "Alfa da Tempestade",
  "worldEvent.boss.abyss": "Alfa do Abismo",

  // 10.9AJ — Zona dos Bosses (Fenda dos Titãs)
  "bossZone.portal": "👑 Fenda dos Titãs",
  "bossZone.exitPortal": "🏠 Voltar ao Santuário",
  "bossZone.enter": "Entrar na Fenda dos Titãs",
  "bossZone.exit": "Voltar ao Santuário",
  "bossZone.welcome": "👑 FENDA DOS TITÃS — cada sala tem um boss. As portas exigem nível.",
  "bossZone.challenge": "👑 Desafiar {name}",
  "bossZone.locked": "🔒 Sala trancada — precisa Nv {n}",
  "bossZone.lockedTree": "🔒 {name} — precisa a Árvore do Void {have}/{need} pts",
  "bossZone.cooldown": "⏳ {name} renasce em {t}",
  "bossZone.awakens": "{name} desperta!",
  "bossZone.defeated": "{name} caiu! +XP, essência e baú. Renasce em {t}.",
  "bossZone.weaponDrop": "⚔️ ARMA DO BOSS! Drop raríssimo — {item}",
  "bossZone.left": "Você saiu da Fenda dos Titãs.",
  "bossZone.r1": "Presa Rubra",
  "bossZone.r2": "Olho Gélido",
  "bossZone.r3": "Alfa da Praga",
  "bossZone.r4": "Vidente Astral",
  "bossZone.r5": "Colmilho Dourado",
  "bossZone.r6": "Olho do Abismo",
  "bossZone.r7": "Alfa Carmesim",
  "bossZone.r8": "Vidente do Vazio",
  "bossZone.r9": "Alfa Primordial",
  "bossZone.r10": "O Olho Final",
  "bossZone.r11": "Guardião Ascendente",
  "bossZone.r12": "Vidente Eterno",
  "bossZone.r13": "Alfa do Abismo",
  "bossZone.r14": "Vidente do Infinito",
  "bossZone.r15": "Titã Ômega",

  "settings.audio": "Áudio",
  "audio.master": "Geral",
  "audio.music": "Música",
  "audio.sfx": "Efeitos",

  "touch.hook": "GANCHO",
  "touch.sprint": "CORRER",
  "touch.spell": "MAGIA",
  "spell.warrior": "Golpe Sísmico",
  "spell.warrior2": "Investida", "spell.warrior2.d": "Avança à frente causando dano e empurrão.",
  "spell.warrior3": "Grito de Guerra", "spell.warrior3.d": "6 s: +30% dano, +40% resistência e cura 15% da vida.",
  "spell.archer2": "Foco do Caçador", "spell.archer2.d": "6 s: +25% dano, +30% vel. de ataque e +15% de crítico.",
  "spell.archer3": "Salto Evasivo", "spell.archer3.d": "Salta à frente (breve invulnerabilidade) ferindo quem cruzar.",
  "spell.mage2": "Meteoro", "spell.mage2.d": "Chama um meteoro à frente — grande dano em área após um instante.",
  "spell.mage3": "Barreira Arcana", "spell.mage3.d": "6 s: +50% de resistência e cura 10% da vida.",
  "spell.necromancer2": "Explosão de Almas", "spell.necromancer2.d": "Explosão arcana em volta do Caçador.",
  "spell.necromancer3": "Praga do Vazio", "spell.necromancer3.d": "Cria uma zona que causa dano ao longo de 4 s.",
  "spell.buffOn": "✨ {name} ativado!",
  "shop.potion": "Poções de Vida ×3",
  "potion.none": "Sem poções — compre na Loja.",
  "potion.full": "Vida já está cheia.",
  "potion.used": "🧪 +{n} de vida!",
  "potion.got": "🧪 +{n} poções!",
  "spell.archer": "Chuva de Flechas",
  "spell.mage": "Nova Arcana",
  "spell.necromancer": "Exército do Vazio",
  "spell.summonCast": "🧟 +{n} servos invocados!",
  "touch.interact": "USAR",

  // ---- Fase 4: equipamento / loot / maestria ----
  "inventory.title": "Bolsa e equipamento",
  "nav.bag": "Bolsa",
  "nav.character": "Herói",
  "nav.tree": "Evoluir",
  "nav.world": "Mundo",
  "inventory.storage": "Bolsa: {count}/{capacity} espaços · coleta automática",
  "inventory.slotEmpty": "Vazio",
  "inventory.equipHint": "Toque em uma arma da bolsa para comparar e equipar. A arma anterior volta para a bolsa.",
  "inventory.bagHint": "Nenhum item neste filtro. Armas e armaduras coletadas aparecem aqui. Cace monstros ou abra baús para encontrar mais.",
  "weaponSlot.mainHand": "MÃO",
  "weaponSlot.soon": "Loadout de armas — em breve",
  "weaponSlot.soonShort": "Em breve",
  "weaponSlot.unlockLevel": "Desbloqueia no Nível {level}",
  "weaponSlot.vip": "Slot de arma VIP: +1 arma atacando na corrente pra quem é VIP ou tem o Passe VIP",
  "weaponSlot.vipActive": "VIP ativo — slot de arma extra liberado (+1 arma na corrente)",
  "inventory.autoBest": "⚡ Equipar arma mais forte",
  "inventory.autoBestDone": "Equipada a arma mais forte: {name}",
  "inventory.autoBestAlready": "Você já está com a arma mais forte",
  "inventory.autoBestNone": "Nenhuma arma na bolsa",
  "inventory.equipBest": "Equipar o melhor",
  "inventory.bestNone": "Nada melhor na bolsa pra equipar",
  "inventory.bestEquippedAll": "Melhor build: {n} armas (mão + corrente) · {armor}",
  "inventory.bestArmorSwapped": "{n} peça(s) de armadura trocada(s)",
  "inventory.bestArmorKept": "armadura já era a melhor",
  "weaponType.sword": "Espada",
  "weaponType.axe": "Machado",
  "weaponType.bow": "Arco",
  "weaponType.crossbow": "Besta",
  "weaponType.tome": "Grimório",
  "weaponType.mace": "Clava",
  "weaponType.staff": "Cajado",
  "inventory.filter.all": "Tudo",
  "inventory.filter.weapon": "Arma",
  "inventory.filter.armor": "Armadura",
  "inventory.filter.accessory": "Acessório",
  "inventory.empty": "Sem itens ainda — cace para achar loot.",
  "inventory.full": "Inventário cheio",

  "equipment.equip": "Equipar",
  "equipment.unequip": "Desequipar",
  "equipment.equipped": "Equipado",
  "equipment.inChain": "Na corrente",
  "equipment.damage": "Dano",
  "equipment.dps": "DPS",
  "equipment.level": "Nv",
  "equipment.mastery": "Maestria",
  "equipment.upgrade": "Evoluir",
  "equipment.shards": "shards",
  "equipment.maxLevel": "Nível máx.",
  "equipment.convert": "Em shards",
  "equipment.slotLocked": "Slot bloqueado",
  "slot.unlock.elite": "Libera ao derrotar 1 Elite — o campeão de qualquer território (coroa)",
  "slot.unlock.gate": "Libera ao abrir o Covil do Alpha",
  "slot.unlock.boss": "Libera ao derrotar o Apex Fang — Floresta Esquecida, no Covil do Alpha (sul do mapa)",
  "slot.unlock.colossus": "Libera ao derrotar o Aether Colossus — Terras Fraturadas, no Portão do Colosso",
  "equipment.head": "Cabeça",
  "equipment.chest": "Peito",
  "equipment.accessory": "Acessório",
  "equipment.attr.damage": "Dano",
  "equipment.attr.attackSpeed": "Vel. de Ataque",
  "equipment.attr.critChance": "Chance Crítica",
  "equipment.attr.critDamage": "Dano Crítico",
  "equipment.attr.maxHp": "HP Máx.",
  "equipment.attr.armor": "Armadura",
  "equipment.attr.moveSpeed": "Vel. Movimento",
  "equipment.attr.attackRange": "Alcance",
  "equipment.attr.dmgSlash": "Dano Cortante",
  "equipment.attr.dmgPierce": "Dano Perfurante",
  "equipment.attr.dmgBlunt": "Dano Contundente",
  "equipment.attr.dmgArcane": "Dano Arcano",
  "equipment.attr.defSlash": "Defesa Cortante",
  "equipment.attr.defPierce": "Defesa Perfurante",
  "equipment.attr.defBlunt": "Defesa Contundente",
  "equipment.attr.block": "Chance de Bloqueio",
  "equipment.attr.regen": "Regeneração",

  "rarity.common": "Comum",
  "rarity.uncommon": "Incomum",
  "rarity.rare": "Raro",
  "rarity.epic": "Épico",
  "rarity.legendary": "Lendário",
  "rarity.mythic": "Mítico",

  "weapon.sword": "Lâmina do Void",
  "weapon.axe": "Machado do Void",
  "weapon.bow": "Arco do Void",
  "weapon.staff": "Cajado do Void",
  "weapon.crossbow": "Besta do Void",
  "weapon.tome": "Grimório do Void",
  "weapon.eclipseBlade": "Lâmina do Eclipse",
  "weapon.eclipseCleaver": "Machado do Eclipse",
  "weapon.eclipseMaul": "Maça do Eclipse",
  "weapon.eclipseBow": "Arco do Eclipse",
  "weapon.eclipseStaff": "Cajado do Eclipse",
  "weapon.eclipseCrossbow": "Besta do Eclipse",
  "weapon.eclipseTome": "Grimório do Eclipse",
  "armor.eclipseCrown": "Elmo do Eclipse",
  "armor.eclipseAegis": "Peitoral do Eclipse",
  "armor.eclipseGrips": "Manoplas do Eclipse",
  "armor.eclipseTreads": "Botas do Eclipse",
  "armor.eclipseSeal": "Selo do Eclipse",
  "weapon.umbralSword": "Lâmina Umbral",
  "weapon.umbralAxe": "Machado Umbral",
  "weapon.umbralMace": "Maça Umbral",
  "weapon.umbralBow": "Arco Umbral",
  "weapon.umbralStaff": "Cajado Umbral",
  "weapon.umbralCrossbow": "Besta Umbral",
  "weapon.umbralTome": "Grimório Umbral",
  "armor.umbralHead": "Elmo Umbral",
  "armor.umbralChest": "Peitoral Umbral",
  "armor.umbralGloves": "Manoplas Umbral",
  "armor.umbralBoots": "Botas Umbral",
  "armor.umbralAccessory": "Selo Umbral",
  "weapon.astralSword": "Lâmina Astral",
  "weapon.astralAxe": "Machado Astral",
  "weapon.astralMace": "Maça Astral",
  "weapon.astralBow": "Arco Astral",
  "weapon.astralStaff": "Cajado Astral",
  "weapon.astralCrossbow": "Besta Astral",
  "weapon.astralTome": "Grimório Astral",
  "armor.astralHead": "Elmo Astral",
  "armor.astralChest": "Peitoral Astral",
  "armor.astralGloves": "Manoplas Astral",
  "armor.astralBoots": "Botas Astral",
  "armor.astralAccessory": "Selo Astral",
  "weapon.sideralSword": "Lâmina Sideral",
  "weapon.sideralAxe": "Machado Sideral",
  "weapon.sideralMace": "Maça Sideral",
  "weapon.sideralBow": "Arco Sideral",
  "weapon.sideralStaff": "Cajado Sideral",
  "weapon.sideralCrossbow": "Besta Sideral",
  "weapon.sideralTome": "Grimório Sideral",
  "armor.sideralHead": "Elmo Sideral",
  "armor.sideralChest": "Peitoral Sideral",
  "armor.sideralGloves": "Manoplas Sideral",
  "armor.sideralBoots": "Botas Sideral",
  "armor.sideralAccessory": "Selo Sideral",
  "weapon.stellarSword": "Lâmina Estelar",
  "weapon.stellarAxe": "Machado Estelar",
  "weapon.stellarMace": "Maça Estelar",
  "weapon.stellarBow": "Arco Estelar",
  "weapon.stellarStaff": "Cajado Estelar",
  "weapon.stellarCrossbow": "Besta Estelar",
  "weapon.stellarTome": "Grimório Estelar",
  "armor.stellarHead": "Elmo Estelar",
  "armor.stellarChest": "Peitoral Estelar",
  "armor.stellarGloves": "Manoplas Estelar",
  "armor.stellarBoots": "Botas Estelar",
  "armor.stellarAccessory": "Selo Estelar",
  "weapon.nebularSword": "Lâmina Nebular",
  "weapon.nebularAxe": "Machado Nebular",
  "weapon.nebularMace": "Maça Nebular",
  "weapon.nebularBow": "Arco Nebular",
  "weapon.nebularStaff": "Cajado Nebular",
  "weapon.nebularCrossbow": "Besta Nebular",
  "weapon.nebularTome": "Grimório Nebular",
  "armor.nebularHead": "Elmo Nebular",
  "armor.nebularChest": "Peitoral Nebular",
  "armor.nebularGloves": "Manoplas Nebular",
  "armor.nebularBoots": "Botas Nebular",
  "armor.nebularAccessory": "Selo Nebular",
  "weapon.abyssalSword": "Lâmina Abissal",
  "weapon.abyssalAxe": "Machado Abissal",
  "weapon.abyssalMace": "Maça Abissal",
  "weapon.abyssalBow": "Arco Abissal",
  "weapon.abyssalStaff": "Cajado Abissal",
  "weapon.abyssalCrossbow": "Besta Abissal",
  "weapon.abyssalTome": "Grimório Abissal",
  "armor.abyssalHead": "Elmo Abissal",
  "armor.abyssalChest": "Peitoral Abissal",
  "armor.abyssalGloves": "Manoplas Abissal",
  "armor.abyssalBoots": "Botas Abissal",
  "armor.abyssalAccessory": "Selo Abissal",
  "weapon.omegaSword": "Lâmina Ômega",
  "weapon.omegaAxe": "Machado Ômega",
  "weapon.omegaMace": "Maça Ômega",
  "weapon.omegaBow": "Arco Ômega",
  "weapon.omegaStaff": "Cajado Ômega",
  "weapon.omegaCrossbow": "Besta Ômega",
  "weapon.omegaTome": "Grimório Ômega",
  "armor.omegaHead": "Elmo Ômega",
  "armor.omegaChest": "Peitoral Ômega",
  "armor.omegaGloves": "Manoplas Ômega",
  "armor.omegaBoots": "Botas Ômega",
  "armor.omegaAccessory": "Selo Ômega",
  "weapon.reaperEclipse": "Ceifa do Eclipse",
  "weapon.ruinEclipse": "Ruína do Eclipse",
  "weapon.collapseEclipse": "Colapso do Eclipse",
  "weapon.omenEclipse": "Presságio do Eclipse",
  "weapon.voidEclipse": "Vazio do Eclipse",
  "weapon.boltEclipse": "Estilhaço do Eclipse",
  "weapon.runeEclipse": "Runa do Eclipse",
  "armor.titanHeart": "Coração do Titã",
  "weapon.aetherScepter": "Cetro de Éter",
  "weapon.arcCrossbow": "Besta Voltaica",
  "weapon.arcaneTome": "Grimório de Éter",
  // 10.9AO — armaduras T4/T5/T6
  // 10.9J7 — RENOMEADO (só o texto, id/nameKey intactos p/ não quebrar item já salvo de jogador):
  // "Abissal" duplicava o nome do tier 13 (quase 20× mais forte) — evolução parecia estagnada.
  "armor.abyssalHelm": "Elmo Glacial",
  "armor.abyssalPlate": "Peitoral Glacial",
  "armor.abyssalGrips": "Manoplas Glaciais",
  "armor.abyssalGreaves": "Grevas Glaciais",
  "armor.abyssalSigil": "Sigilo Glacial",
  "armor.titanCrown": "Coroa do Titã",
  "armor.titanBulwark": "Baluarte do Titã",
  "armor.titanGauntlets": "Manoplas do Titã",
  "armor.titanTreads": "Botas do Titã",
  "armor.titanSeal": "Selo do Titã",
  "armor.primordialCrown": "Coroa Primordial",
  "armor.primordialAegis": "Égide Primordial",
  "armor.primordialFists": "Punhos Primordiais",
  "armor.primordialStriders": "Passos Primordiais",
  "armor.primordialHeart": "Coração Primordial",
  "weapon.mace": "Clava do Void",
  "weapon.stormMaul": "Maça da Tempestade",
  "armor.head": "Elmo do Void",
  "armor.chest": "Peitoral do Void",
  "armor.accessory": "Amuleto do Void",
  "armor.shardHelm": "Elmo de Cristal",
  "armor.tempestVisor": "Viseira da Tempestade",
  "armor.wardenPlate": "Peitoral do Guardião",
  "armor.tempestMail": "Malha da Tempestade",
  "armor.shardGrips": "Manoplas de Cristal",
  "armor.galeWraps": "Envoltórios de Vento",
  "armor.aetherGauntlets": "Manoplas de Aether",
  "armor.tempestGrips": "Manoplas da Tempestade", // 10.9J7 — T3, fecha o buraco de luvas Nv35-49
  "armor.riftwalkBoots": "Botas Riftwalk",
  "armor.galestepBoots": "Botas Passo-Vento",
  "armor.stonepathGreaves": "Grevas de Pedra",
  "armor.aetherRing": "Anel de Aether",
  "armor.prismCharm": "Amuleto Prisma",
  "armor.stormSigil": "Sigilo da Tempestade",
  "armor.tempestSigil": "Sigilo do Temporal", // 10.9J7 — T3, fecha o buraco de acessório Nv35-49 (nome distinto do stormSigil T2 de propósito)

  "chest.wooden": "Baú de Madeira (até raro)",
  "chest.void": "Baú do Void (até épico)",
  "chest.alpha": "Baú do Alpha (até lendário)",
  "chest.openTag": "Abrir baú", // 10.9EX
  "vip.soon": "Em breve", // 10.9FB
  // 10.9FC — Grimorio
  "index.title": "Índice",
  "index.count": "{got}/{total} descobertos",
  "index.tier": "Tier {n}",
  "grim.title": "Grimório",
  "grim.hint": "Toque num botão de magia (1, 2 ou 3) e depois na magia que vai nele.",
  "grim.buff": "BUFF",
  "grim.lvl": "Nv {n}",
  "spell.noTarget": "Nenhum alvo por perto",
  "spell.x.whirl": "Redemoinho",
  "spell.x.whirl.d": "Gira por 2,5 s acertando tudo em volta (10 golpes).",
  "spell.x.shockwave": "Onda de Choque",
  "spell.x.shockwave.d": "Golpe em linha de 12 m à frente que empurra os monstros.",
  "spell.x.battlecry": "Brado de Batalha",
  "spell.x.battlecry.d": "8 s: +50% dano, +40% velocidade de ataque e cura 25% da vida.",
  "spell.x.pierce": "Flecha Perfurante",
  "spell.x.pierce.d": "Tiro de 22 m que atravessa todos na linha.",
  "spell.x.trap": "Armadilha Explosiva",
  "spell.x.trap.d": "Planta no chão; explode forte quando um monstro chega perto.",
  "spell.x.eagle": "Olho de Águia",
  "spell.x.eagle.d": "8 s: +35% de chance de crítico e +30% de dano.",
  "spell.x.chain": "Corrente de Raios",
  "spell.x.chain.d": "Raio que salta entre até 6 monstros.",
  "spell.x.blizzard": "Nevasca",
  "spell.x.blizzard.d": "Área à frente por 5 s: dano e deixa os monstros 50% mais lentos.",
  "spell.x.arcshield": "Escudo Arcano",
  "spell.x.arcshield.d": "6 s: recebe 50% menos dano e cura 10% da vida.",
  "spell.x.bones": "Explosão de Ossos",
  "spell.x.bones.d": "Rajada de ossos em linha de 14 m.",
  "spell.x.drain": "Drenar Vida",
  "spell.x.drain.d": "Área por 5 s que causa dano e cura você a cada monstro atingido.",
  "spell.x.bonearmor": "Armadura de Ossos",
  "spell.x.bonearmor.d": "8 s: -40% de dano recebido, +25% de dano e cura 15% da vida.",
  // 10.9FE — auditoria UX
  "inv.full": "Bolsa cheia — venda itens",
  "voidTree.startHint": "Toque no Núcleo (no topo) pra gastar seus pontos",
  "world.needGoals": "Missões da área",
  "mbar.inv": "Bolsa",
  "mbar.shop": "Loja",
  "mbar.missions": "Missões",
  "mbar.mail": "Correio",
  "mbar.vip": "VIP",
  "gift.weapons": "🎁 Presente: {n} armas lendárias na sua bolsa! (compensação)", // 10.9FL
  "mail.itemsLabel": "itens",
  "mail.elixirsLabel": "Elixir de Proteção",
  "mail.weekly.title": "🎁 Baú Semanal",
  "mail.weekly.body": "{weeks} semana(s) seguidas entrando todo dia! Aqui vai um baú extra — com Elixir de Proteção pra forja.",
  "mail.gift.title": "Presente de compensação",
  "mail.gift.body": "Desculpe pelo bug das armas! Aceite 3 armas lendárias da sua classe.",
  "bossguide.title": "Guia de Bosses",
  "bossguide.hint": "Derrote bosses pra ganhar ARMAS e ROUPAS de boss. No Nv 150 sai o equipamento Eclipse.",
  "bossguide.alpha": "Apex Fang",
  "bossguide.alpha.where": "Floresta Esquecida — após cumprir os objetivos da área.",
  "bossguide.colossus": "Aether Colossus",
  "bossguide.colossus.where": "Terras Fraturadas (Nv 10+) — no portão do Colosso.",
  "bossguide.guardian": "Guardião da Região",
  "bossguide.guardian.where": "Um por região — desperta ao limpar a área; entre na arena pra desafiar.",
  "bossguide.rift": "Fenda dos Titãs",
  "bossguide.rift.where": "Portal no sudeste do Santuário — salas por nível, cada uma com um boss.",
  "bossguide.titan": "Titã do Eclipse (boss global)",
  "bossguide.titan.where": "Evento em horários fixos — solta o equipamento Eclipse (Nv 150).",
  "chest.opened": "Baú aberto",
  "chest.bossWeapon": "⚔️ Arma de Boss no baú!",
  "loot.obtained": "{rarity} {name} obtido",
  "loot.toShards": "{name} repetido → +{n} shards",
  "evolve.copy": "+1 cópia de {name} → evolução {bar}/{need} · +{n} shards",
  "evolve.bar": "⚗️ Evolução: {bar}/{need} cópias iguais → {rarity}",
  "evolve.needLevel": "Barra cheia! Evolui sozinha pra {rarity} no Nv {lvl}",
  "evolve.how": "Cada cópia desta arma (mesma raridade) que cair entra aqui e ainda dá shards pra forja. Ao completar, ela sobe de raridade e mantém o nível de forja.",
  "evolve.maxRarity": "⚗️ Raridade máxima — cópias iguais viram shards pra forja",
  "evolve.done": "⚗️ {name} evoluiu! Agora é {rarity}",
  "evolve.migrated": "⚗️ {n} arma(s) repetida(s) da bolsa entraram na barra de evolução",
  "mail.refund.title": "Reembolso: Fusão Automática",
  "mail.refund.body": "A fusão de 5 armas virou a EVOLUÇÃO automática (100 cópias iguais → raridade acima), grátis pra todos. Os diamantes que você pagou voltaram.",
  "loot.offClassSold": "{name} não é da sua classe → vendido +{n} 🪙",
  "loot.offClassSwept": "{n} arma(s) de outra classe na bolsa foram vendidas: +{coins} 🪙",
  "loot.weaponCopy": "{name} repetido → +1 cópia",
  "shop.cat.consumable": "Consumíveis",
  "shop.cat.boost": "Impulsos",
  "shop.cat.permanent": "Permanentes",
  "shop.cat.rings": "Anéis de Proteção",
  "shop.cat.pet": "Companheiro",
  "shop.cat.resource": "Recursos",
  "shop.cat.protect": "Proteção",
  "shop.cat.chest": "Baús",
  "shop.cat.cosmetic": "Cosmético",
  "shop.title": "Loja",
  "shop.subtitle": "Gaste as moedas ganhas jogando",
  "shop.bought": "{name} comprado!",
  "shop.noCoins": "Fragmentos insuficientes",
  "hazard.frost": "frio extremo",
  "hazard.ember": "calor extremo",
  "hazard.gale": "vendaval",
  "hazard.storm": "tempestade elétrica",
  "hazard.warn": "⚠ {what} — você começa a perder vida em {n}s",
  "hazard.hurt": "☠ {what} — você está perdendo vida!",
  "hazard.equipIt": "👉 Toque pra equipar o {ring} (está na sua Bolsa)",
  "hazard.buyIt": "👉 Proteção: {ring} · Loja 🪙 {n} — toque pra abrir",
  "hazard.needSlot": "Proteção: {ring} (Loja) — o espaço de acessório abre ao {how}",
  "armor.ringEmber": "Anel de Brasa",
  "armor.ringFrost": "Anel de Geada",
  "armor.ringGale": "Anel da Ventania",
  "armor.ringStorm": "Anel da Tempestade",
  "shop.item.ringEmber.name": "Anel de Brasa",
  "shop.item.ringEmber.desc": "Protege do frio extremo · equipa a partir do Nv 16",
  "shop.item.ringFrost.name": "Anel de Geada",
  "shop.item.ringFrost.desc": "Protege do calor extremo · equipa a partir do Nv 16",
  "shop.item.ringGale.name": "Anel da Ventania",
  "shop.item.ringGale.desc": "Protege do vendaval · equipa a partir do Nv 16",
  "shop.item.ringStorm.name": "Anel da Tempestade",
  "shop.item.ringStorm.desc": "Protege da tempestade elétrica · equipa a partir do Nv 16",
  "shop.ringBought": "{name} foi para a bolsa — equipe no acessório",
  "shop.needWeapon": "Equipe uma arma primeiro",
  "shop.item.potion.name": "Poções de Vida",
  "shop.item.potion.desc": "Cura na hora quando usar — pacote de {n}",
  "shop.item.heal.name": "Cura Total",
  "shop.item.heal.desc": "Restaura toda a vida agora",
  "shop.item.hp.name": "Reforço de Vida",
  "shop.item.hp.desc": "+{n} de vida máxima (permanente)",
  "shop.item.power.name": "Reforço de Poder",
  "shop.item.power.desc": "+{n} de dano (permanente)",
  "shop.item.shards.name": "Fragmentos de Evolução",
  "shop.item.shards.desc": "+{n} shards da arma equipada",
  "shop.bought.count": "já comprado {n}×",
  "shop.item.forge.name": "Shards da Arma",
  "shop.item.forge.desc": "+{n} shards ✨ da arma equipada (material pra forjar)",
  "shop.item.voidPoint.name": "Ponto do Void",
  "shop.item.voidPoint.desc": "+{n} ponto para gastar na Árvore do Void",
  "shop.item.contract.name": "Contrato de Caça",
  "shop.item.contract.desc": "+75% de Fragmentos por 5 minutos",
  "shop.item.hunt.name": "Chamado de Elite",
  "shop.item.hunt.desc": "Invoca um Elite perto de você (loot alto)",
  "shop.huntFail": "Saia da base (e sem boss em campo) para chamar um Elite",
  "shop.contractOn": "Contrato de Caça ativo!",
  "shop.item.pet.name": "Companheiro",
  "shop.item.pet.desc": "Orbe que voa atrás da essência, ganha nível com abates e dá dano ao Caçador",
  "shop.owned": "Adquirido",
  "shop.alreadyOwned": "Você já tem o companheiro",
  "pet.levelUp": "🐾 Companheiro Nv {n}!",
  "pet.shopLevel": "Nv {n}",
  "wardrobe.title": "Guarda-Roupa",
  "wardrobe.live": "Prévia ao vivo · arraste para girar",
  "wardrobe.equip": "Equipar",
  "wardrobe.equipped": "Equipado",
  "wardrobe.wearing": "Vestindo {name}",
  "outfit.void.name": "Vazio",
  "outfit.void.desc": "Traje padrão do Hunter",
  "outfit.aether.name": "Aether",
  "outfit.aether.desc": "Dourado radiante",
  "outfit.tempest.name": "Tempestade",
  "outfit.tempest.desc": "Turquesa da tormenta",
  "outfit.ember.name": "Brasa",
  "outfit.ember.desc": "Laranja incandescente",
  "outfit.astral.name": "Astral",
  "outfit.astral.desc": "Rosa astral",
  "outfit.gold.name": "Ouro VIP",
  "outfit.gold.desc": "Dourado real (loja de 💎)",
  "outfit.obsidian.name": "Obsidiana",
  "outfit.obsidian.desc": "Negro polido com brilho ciano (loja de 💎)",
  "outfit.royal.name": "Realeza",
  "outfit.royal.desc": "Carmesim profundo com dourado (loja de 💎)",
  "outfit.aurora.name": "Aurora",
  "outfit.aurora.desc": "Azul-noite, violeta e cristal verde — exclusiva do Passe VIP",
  "outfit.eclipse.name": "Eclipse",
  "outfit.eclipse.desc": "Negro com brasa âmbar — linhagem do Titã",
  "outfit.sideral.name": "Sideral",
  "outfit.sideral.desc": "Aço-gelo e luz estelar",
  "outfit.abyssal.name": "Abissal",
  "outfit.abyssal.desc": "Carmesim das profundezas",
  "outfit.omega.name": "Ômega",
  "outfit.omega.desc": "Branco e ouro — o fim da escada",
  "wardrobe.buy": "Comprar",
  "wardrobe.exclusive": "🔒 Exclusiva da Loja VIP (💎)",
  "wardrobe.exclusivePass": "🔒 Exclusiva do Passe VIP",

  "mastery.level": "Maestria Nv",
  "mastery.nextReward": "Próximo",
  "mastery.max": "Maestria no máximo",
  "mastery.endless": "Sem teto: +{p}% de dano a cada nível daqui pra frente",
  "mastery.levelUp": "Maestria Nv {n}!",
  "mastery.trait.voidEdge": "Fio do Void",
  "mastery.trait.cleave": "Talho",
  "mastery.trait.executioner": "Carrasco",
  "mastery.trait.voidShot": "Tiro do Void",

  "slot.unlocked.head": "Slot de Cabeça liberado!",
  "slot.unlocked.chest": "Slot de Peito liberado!",
  "slot.unlocked.accessory": "Slot de Acessório liberado!",
  "slot.unlocked.gloves": "Slot de Luvas liberado!",
  "slot.unlocked.boots": "Slot de Botas liberado!",
  "weaponLevel.level": "NÍVEL",
  "weaponLevel.damage": "DANO",
  "weaponLevel.title": "Nível da Arma",
  "weaponLevel.copies": "Cópias",
  "weaponLevel.next": "Próximo",
  "weaponLevel.maxed": "NÍVEL MÁX",
  "wm.crit": "+Chance de Crítico",
  "wm.speed": "+Vel. de Ataque",
  "wm.damage": "+Dano",
  "wm.crit2": "+Chance de Crítico",
  "wm.master": "+Dano (Mestre)",
  "slot.weapon": "Arma",
  "slot.head": "Cabeça",
  "slot.chest": "Peito",
  "slot.gloves": "Luvas",
  "slot.boots": "Botas",
  "slot.accessory": "Acessório",
  "inv.all": "Todos",

  // ---- Fase 5: minimapa / responsivo / acessibilidade ----
  "map.discovered": "Área descoberta",
  "map.sanctuary": "Santuário do Void",
  "map.altar": "Altar do Void",
  "map.alphaDen": "Covil do Alpha",
  "settings.accessibility": "Acessibilidade",
  "settings.uiScale": "Escala da UI",
  "settings.uiScaleSmall": "Pequena",
  "settings.uiScaleDefault": "Padrão",
  "settings.uiScaleLarge": "Grande",
  "settings.reducedMotion": "Menos Movimento",
  "settings.graphics": "Gráficos",
  "perf.autoLower": "⚙️ Gráficos ajustados para {n} (desempenho)",
  "gate.title": "Guarde seu progresso",
  "gate.sub": "Criar uma conta leva 10 segundos e garante que você não perde o Caçador se trocar de celular.",
  "gate.google": "Entrar com Google",
  "gate.void": "Tenho um ID do Void (e-mail)",
  "gate.email": "E-mail",
  "gate.pass": "Senha (6+ caracteres)",
  "gate.create": "Criar conta",
  "gate.enter": "Entrar",
  "gate.guest": "Jogar como convidado",
  "gate.note": "Dá pra criar a conta depois, pelo Ranking, sem perder nada do que já jogou.",
  "graphics.low": "Baixo",
  "graphics.medium": "Médio",
  "graphics.high": "Alto",
  "common.on": "Ligado",
  "common.off": "Desligado",
  "orientation.rotateDevice": "Vire o dispositivo para retrato",

  // ---- Fase 6: Personagem / Void Tree ----
  "character.title": "Caçador",
  "character.combatPower": "Poder de Combate",
  "character.level": "Nível",
  "character.progression": "Progressão",
  "levelUp.voidPoint": "Void Point",

  "voidTree.title": "Árvore do Void",
  "voidTree.points": "Pontos",
  "voidTree.reset": "Resetar",
  "voidTree.resetConfirm": "Resetar a Árvore do Void? Todos os pontos gastos retornam.",
  "voidTree.resetConfirmFree": "Resetar a Árvore do Void? Todos os pontos voltam. O 1º reset é GRÁTIS.",
  "voidTree.resetConfirmCost": "Resetar a Árvore do Void? Todos os pontos voltam. Custa 💎 {cost}.",
  "voidTree.resetDone": "Árvore resetada!",
  "voidTree.resetPaid": "Árvore resetada! (−{cost} 💎)",
  "voidTree.unlock": "Desbloquear",
  "voidTree.upgrade": "Evoluir",
  "voidTree.rank": "Rank",
  "voidTree.requires": "Requer",
  "voidTree.next": "Próximo",
  "voidTree.atMax": "Cheio (rank {n})", // 10.9EH
  "voidTree.max": "TUDO", // 10.9EG — compra em lote
  "voidTree.maxed": "Máximo",

  "branch.power": "Poder",
  "branch.survival": "Sobrevivência",
  "branch.agility": "Agilidade",
  "branch.class": "Classe",
  "treeeffect.summonHpPct": "Vida (HP) dos servos",
  "treeeffect.spellHealOnCast": "Cura ao lançar a magia",
  "treeeffect.spellCritBonus": "Crítico da magia",
  "node.cls_war_rage": "Sangue de Guerra", "node.cls_war_guard": "Muralha", "node.cls_war_guard.d": "Ao usar o Golpe Sísmico você se cura em 5% da vida máxima por rank.",
  "node.cls_arc_pierce": "Perfuração", "node.cls_arc_rain": "Dilúvio",
  "node.cls_mag_surge": "Sobrecarga", "node.cls_mag_font": "Fonte Arcana", "node.cls_mag_font.d": "Ao lançar a Nova você se cura em 5% da vida máxima por rank.",
  "node.cls_nec_hp": "Carne do Vazio", "node.cls_nec_hp.d": "Agora os servos TÊM VIDA e servem de isca (os inimigos batem neles). +30% de HP por rank.",
  "node.cls_nec_reap": "Colheita do Vazio",
  "treeeffect.spellDamagePct": "Dano da Magia",
  "treeeffect.spellRadiusPct": "Raio da Magia",
  "treeeffect.spellCdReducPct": "Recarga da Magia (menor)",
  "treeeffect.summonCount": "Servos por invocação",
  "treeeffect.summonLifePct": "Tempo de vida dos servos",
  "treeeffect.summonSpeedPct": "Velocidade de ataque dos servos",
  "node.cls_war_dmg": "Golpe Pesado", "node.cls_war_radius": "Onda de Choque", "node.cls_war_cd": "Fôlego de Guerra", "node.cls_war_quake": "Terremoto",
  "node.cls_arc_dmg": "Pontas Afiadas", "node.cls_arc_radius": "Chuva Larga", "node.cls_arc_cd": "Aljava Rápida", "node.cls_arc_storm": "Tempestade de Flechas",
  "node.cls_mag_dmg": "Foco Arcano", "node.cls_mag_radius": "Nova Expandida", "node.cls_mag_cd": "Mente Veloz", "node.cls_mag_cataclysm": "Cataclismo",
  "node.cls_nec_dmg": "Garras do Vazio", "node.cls_nec_life": "Vida dos Servos", "node.cls_nec_life.d": "Os servos são espectros: não têm vida — o que vale é o TEMPO. +25% de duração por rank.",
  "node.cls_nec_cd": "Chamado Rápido", "node.cls_nec_speed": "Fúria dos Servos", "node.cls_nec_count": "Mais Servos", "node.cls_nec_count.d": "+1 servo por invocação (e +2 no teto de servos vivos) por rank.",
  "node.cls_nec_legion": "Legião do Vazio",

  "stat.damage": "Dano",
  "stat.maxHp": "HP Máx.",
  "stat.armor": "Armadura",
  "stat.moveSpeed": "Vel. Movimento",
  "stat.attackSpeed": "Vel. de Ataque",
  "stat.criticalChance": "Chance Crítica",
  "stat.criticalDamage": "Dano Crítico",
  "stat.attackRange": "Alcance",
  "stat.hookRange": "Alcance do Gancho",
  "stat.hookCooldown": "Recarga do Gancho",
  "stat.sprintDuration": "Duração do Sprint",
  "stat.sprintCooldown": "Recarga do Sprint",
  "stat.dps": "Dano por Segundo",
  "stat.regen": "Regeneração",
  "stat.dmgSlash": "Dano Cortante",
  "stat.dmgPierce": "Dano Perfurante",
  "stat.dmgBlunt": "Dano Contundente",
  "stat.defSlash": "Defesa Cortante",
  "stat.defPierce": "Defesa Perfurante",
  "stat.defBlunt": "Defesa Contundente",
  "stat.block": "Chance de Bloqueio",
  "stat.resilience": "Resiliência",
  "stat.vsElite": "Dano vs Elite/Boss",
  "stat.execute": "Dano de Execução",
  "stat.chainCount": "Armas presas",
  "stat.chainDps": "DPS da Corrente",
  "stat.chainReach": "Alcance da Corrente",

  "attr.title": "ATRIBUTOS",
  "attr.dps": "DPS",
  "attr.hp": "VIDA",
  "attr.regen": "REGEN/s",
  "attr.dmgTaken": "de dano recebido",
  "attr.group.general": "Geral",
  "attr.group.damage": "Dano",
  "attr.group.defense": "Defesa",
  "attr.group.mobility": "Mobilidade",
  "attr.group.chain": "Corrente de armas",
  "attr.foot": "Cortante = espada/machado · Perfurante = arco · Contundente = clava. Evolua tudo na Árvore do Void (✦).",

  "source.base": "Base",
  "source.level": "Nível",
  "source.altar": "Altar do Void",
  "source.equipment": "Equipamento",
  "source.voidTree": "Árvore do Void",

  "treeeffect.damagePct": "Dano",
  "treeeffect.critChance": "Chance Crítica",
  "treeeffect.critDamagePct": "Dano Crítico",
  "treeeffect.attackSpeedPct": "Vel. de Ataque",
  "treeeffect.maxHpPct": "HP Máx.",
  "treeeffect.armorFlat": "Armadura",
  "treeeffect.moveSpeedPct": "Vel. Movimento",
  "treeeffect.hookRangePct": "Alcance do Gancho",
  "treeeffect.hookCdReducPct": "Redução Recarga Gancho",
  "treeeffect.sprintDurationPct": "Duração do Sprint",
  "treeeffect.sprintCdReducPct": "Redução Recarga Sprint",
  "treeeffect.vsElitePct": "Dano vs Elite",
  "treeeffect.executePct": "Dano de Execução",
  "treeeffect.resiliencePct": "Resiliência",
  "treeeffect.dmgSlashPct": "Dano Cortante",
  "treeeffect.dmgArcanePct": "Dano Arcano",
  "node.pow_arcane": "Poder Arcano",
  "node.pow_rawdmg": "Dano Bruto",
  "treeeffect.dmgPiercePct": "Dano Perfurante",
  "treeeffect.dmgBluntPct": "Dano Contundente",
  "treeeffect.defSlashPct": "Defesa Cortante",
  "treeeffect.defPiercePct": "Defesa Perfurante",
  "treeeffect.defBluntPct": "Defesa Contundente",
  "treeeffect.blockChance": "Chance de Bloqueio",
  "treeeffect.regenPct": "Regeneração",
  "treeeffect.attackRangeFlat": "Alcance",

  "node.pow_slash": "Fio Cortante",
  "node.pow_pierce": "Ponta Perfurante",
  "node.pow_blunt": "Impacto Brutal",
  "node.sur_regen": "Pulso do Void",
  "node.sur_regen.d": "Regenera vida continuamente, até em combate (0,5% do HP máx./s por rank).",
  "node.sur_defslash": "Pele de Aço",
  "node.sur_defpierce": "Placas do Void",
  "node.sur_defblunt": "Corpo de Rocha",
  "node.sur_block": "Guarda do Caçador",
  "node.sur_block.d": "Chance de BLOQUEAR golpes: dano pela metade e menos empurrão (+4% por rank).",

  "node.pow_core": "Núcleo de Poder",
  "node.pow_heavy": "Golpe Pesado",
  "node.agi_reach": "Envergadura",
  "node.agi_reach.d": "Aumenta o alcance da sua arma (+0,25 m por rank).",
  "node.pow_dmg1": "Poder",
  "node.pow_atkspd": "Ritmo de Ataque",
  "node.pow_crit": "Instinto Afiado",
  "node.pow_dmg2": "Sobrepujar",
  "node.pow_ferocity": "Ferocidade",
  "node.pow_hunter": "Foco do Caçador",
  "node.pow_hunter.d": "Mais dano contra Elites e o Boss (por rank).",
  "node.pow_exec": "Execução do Void",
  "node.pow_exec.d": "Mais dano contra inimigos abaixo de 30% de HP (por rank).",
  "node.pow_dominance": "Domínio do Void",
  "node.pow_dominance.d": "Após 5 abates em 10s, +10% de Dano por 5s.",
  "node.sur_hp1": "Vitalidade",
  "node.sur_armor": "Fortitude",
  "node.sur_hp2": "Resistência",
  "node.sur_resil": "Resiliência do Void",
  "node.sur_resil.d": "Reduz o dano recebido (por rank).",
  "node.sur_secondwind": "Fôlego Extra",
  "node.sur_secondwind.d": "Abaixo de 25% de HP, recupera 25% (recarga 30s).",
  "node.sur_unbreakable": "Inquebrável",
  "node.sur_unbreakable.d": "Sobrevive a um golpe fatal com 1 HP (recarga 120s).",
  "node.agi_move": "Ligeiro",
  "node.agi_atkspd": "Reflexos de Caçador",
  "node.agi_sprintdur": "Controle de Sprint",
  "node.agi_sprintcd": "Recuperação de Sprint",
  "node.agi_hookrange": "Alcance do Gancho",
  "node.agi_hookcd": "Recuperação do Gancho",
  "node.agi_predator": "Predador",
  "node.agi_predator.d": "Após um abate, +20% de Vel. de Movimento por 2s.",
  "node.agi_voidstep": "Passo do Void",
  "node.agi_voidstep.d": "Ao iniciar o Sprint, -30% de dano recebido por 0,6s.",
  "node.pow_rage": "Fúria",
  "node.pow_precision": "Precisão Absoluta",
  "node.pow_savagery": "Selvageria",
  "node.pow_bloodedge": "Fio de Sangue",
  "node.pow_apex": "Ápice do Caçador",
  "node.pow_apex.d": "Capstone: +50% dano e +15% velocidade de ataque.",
  "node.sur_fortitude": "Fortitude",
  "node.sur_ironskin": "Pele de Ferro",
  "node.sur_veteran": "Veterano",
  "node.sur_regenmaster": "Mestre da Regeneração",
  "node.sur_bastion": "Bastião",
  "node.sur_bastion.d": "Capstone: +50% vida máxima e +15% resiliência.",
  "node.agi_swiftness": "Rapidez",
  "node.agi_flurry": "Rajada",
  "node.agi_dodge": "Esquiva",
  "node.agi_relentless": "Implacável",
  "node.agi_wraith": "Espectro",
  "node.agi_wraith.d": "Capstone: +30% velocidade e +15% chance de bloqueio.",
  // 10.9EF — MAESTRIA DE CLASSE (capstone + nos infinitos)
  "node.cls_war_apex": "Ápice do Guerreiro", "node.cls_war_apex.d": "Fecha o caminho do Guerreiro: +20% de dano, +20 de armadura e +25% no Golpe Sísmico. Abre a Maestria sem fim.",
  "node.cls_war_inf_might": "Força Sem Fim", "node.cls_war_inf_bulwark": "Muralha Sem Fim", "node.cls_war_inf_quake": "Tremor Sem Fim",
  "node.cls_arc_apex": "Ápice do Arqueiro", "node.cls_arc_apex.d": "Fecha o caminho do Arqueiro: +20% de dano perfurante, +1,5 m de alcance e +25% na Chuva de Flechas. Abre a Maestria sem fim.",
  "node.cls_arc_inf_aim": "Mira Sem Fim", "node.cls_arc_inf_swift": "Ligeireza Sem Fim", "node.cls_arc_inf_volley": "Saraivada Sem Fim",
  "node.cls_mag_apex": "Ápice do Mago", "node.cls_mag_apex.d": "Fecha o caminho do Mago: +40% de dano de magia e +15% de raio. Abre a Maestria sem fim.",
  "node.cls_mag_inf_arcane": "Arcano Sem Fim", "node.cls_mag_inf_flow": "Fluxo Sem Fim", "node.cls_mag_inf_focus": "Foco Sem Fim",
  "node.cls_nec_apex": "Ápice do Necromante", "node.cls_nec_apex.d": "Fecha o caminho do Necromante: +1 servo, +50% de vida dos servos e +25% de dano. Abre a Maestria sem fim.",
  "node.cls_nec_inf_horde": "Horda Sem Fim", "node.cls_nec_inf_frenzy": "Frenesi Sem Fim", "node.cls_nec_inf_blight": "Praga Sem Fim",
  "node.pow_inf_dmg": "Dano Sem Fim",
  "node.pow_inf_crit": "Crítico Sem Fim",
  "node.pow_inf_atkspd": "Fúria Sem Fim",
  "node.sur_inf_hp": "Vida Sem Fim",
  "node.sur_inf_armor": "Blindagem Sem Fim",
  "node.sur_inf_regen": "Cura Sem Fim",
  "node.agi_inf_speed": "Passo Sem Fim",
  "node.agi_inf_atkspd": "Rajada Sem Fim",
  "node.agi_inf_range": "Alcance Sem Fim",

  // ---- Fase 7: Void Sanctuary 2.0 (safe zone) ----
  "sanctuary.safeZone": "ZONA SEGURA",
  "sanctuary.combatDisabled": "Combate desativado na base",
  "sanctuary.leaving": "SAINDO DA BASE",
  "sanctuary.combatZone": "ZONA DE COMBATE",
  "sanctuary.healing": "Regenerando",
  "combat.invalidFromSafeZone": "Não pode atacar da Zona Segura",

  // ---- Fase 8: Mundo / Regiões / Criaturas ----
  "region2.forgottenForest": "Floresta Esquecida",
  "region2.shatteredWilds": "Terras Fraturadas",
  "region.crystalFlats": "Planícies de Cristal",
  "region.brokenPass": "Passagem Quebrada",
  "region.aetherCliffs": "Penhascos de Éter",
  "region.wardenGrounds": "Domínio do Guardião",

  "enemy.shardfang": "Shardfang",
  "enemy.craghorn": "Craghorn",
  "enemy.aetherwing": "Aetherwing",
  "enemy.glintback": "Glintback",
  "enemy.shardWarden": "Shard Warden",

  "weapon.shardSaber": "Sabre de Estilhaço",

  "chest.ruined": "Baú Arruinado",
  "chest.shard": "Baú de Estilhaço",

  "rift.toWilds": "Entrar nas Terras Fraturadas",
  "rift.toForest": "Voltar à Floresta Esquecida",
  "rift.inactive": "Portal inativo — derrote o Apex Fang",
  "rift.gate": "🌀 Portal Rift",
  "rift.sub": "→ {name} · Nv {n}+",
  "bossZone.portalSub": "Bosses por nível · loot raro",
  "pvp.portalSub": "1x1 · 3x3 · ao vivo",
  "region.entering": "ENTRANDO EM {name}",
  "map.rift": "Portal Rift",
  "map.wilds": "Terras Fraturadas",
  "enemy.grounded": "DERRUBADO",

  // ---- Fase 9: Aether Colossus ----
  "boss.aetherColossus": "AETHER COLOSSUS",
  "boss.awakensColossus": "O AETHER COLOSSUS DESPERTA",
  "boss.crystalArmor": "Armadura Cristalina",
  "boss.coreExposed": "NÚCLEO DE AETHER EXPOSTO",
  "boss.crystalBreak": "PLACA QUEBRADA",
  "boss.hookPlate": "GANCHO!",
  "boss.aetherCore": "Núcleo de Aether",
  "reward.aetherCore": "Núcleo de Aether adquirido",
  "region.shatteredWildsCleared": "TERRAS FRATURADAS CONCLUÍDAS",
  "colossus.gate": "Portão do Colosso",
  "colossus.enter": "Enfrentar o Aether Colossus",
  "colossus.locked": "Selado — derrote os Guardiões e explore as Terras Fraturadas",
  "colossus.arena": "Fratura Ancestral",
  "path.unknown": "CAMINHO DESCONHECIDO",

  // ---- Fase 10: Tempest Reach (Região 3) ----
  "region.tempestReach": "Domínio da Tempestade",
  "region.windwardPath": "Trilha dos Ventos",
  "region.skyruinTerrace": "Terraço das Ruínas Celestes",
  "region.thunderstoneRidge": "Cume das Pedras-Trovão",
  "region.tempestCrown": "Coroa da Tempestade",
  "region.tempestReachUnlocked": "NOVA REGIÃO DESBLOQUEADA — DOMÍNIO DA TEMPESTADE",
  "region.stormBeyond": "UMA TEMPESTADE DESPERTA ADIANTE",
  "enemy.galestrider": "Galestrider",
  "enemy.arcbeak": "Arcbeak",
  "enemy.stormback": "Stormback",
  "enemy.cloudstalker": "Cloudstalker",
  "enemy.tempestWarden": "Guardião da Tempestade",
  "rift.toTempest": "Entrar no Domínio da Tempestade",
  "rift.open": "🌀 Viajar pelo Portal Rift",
  "map.tempest": "Domínio da Tempestade",
  "weapon.galeBlade": "Lâmina Ventania",
  "weapon.tempestCleaver": "Machado Tempestade",
  "weapon.arcLongbow": "Arco Voltaico",
  "chest.skyruin": "Baú das Ruínas Celestes",
  "chest.tempest": "Baú da Tempestade (até mítico)",

  // Tela de viagem entre regiões
  // 10.5O — MISSÕES (com recompensa)
  "mission.title": "MISSÕES",
  "mission.done": "MISSÃO CONCLUÍDA",
  "mission.ready": "Missão cumprida",
  "mission.claim": "Coletar recompensa",
  "mission.sub": "Cumpra e receba na hora — outra missão entra no lugar, maior.",
  "mission.total": "Missões cumpridas: {n}",
  "mission.doneTimes": "· já cumprida {n}×",
  "mission.reward": "Prêmio",
  "mission.m_kill": "Abater monstros",
  "mission.m_elite": "Derrotar Elites",
  "mission.m_chest": "Abrir baús",
  "mission.m_explore": "Explorar territórios",
  "mission.m_hunt": "Grande caçada",
  "mission.m_boss": "Derrotar um Boss",

  // 10.5M — TERRITÓRIOS (30 pedaços de mapa, cada um com sua gangue)
  "terr.gang": "gangue: {name}",
  "terr.tier": "Tier {n}",
  "terr.here": "Você está aqui",
  "terr.cleared": "{name} conquistado — a porta abriu",
  "daily.title": "Diária",
  "daily.ready": "Missão diária cumprida — colete o prêmio",
  "daily.done": "Diária coletada",
  "daily.claimed": "Coletada — volta amanhã",
  "daily.streak": "{n} diárias cumpridas",
  "mission.d_kill": "Abater monstros",
  "mission.d_elite": "Derrotar campeões",
  "mission.d_chest": "Abrir baús",
  "mission.d_territory": "Explorar territórios",
  "mission.d_hunt": "Grande caçada do dia",
  "mission.d_boss": "Derrotar um boss",
  "mission.d_elite2": "Caçada de campeões",
  "terr.task.hunt": "abater {n} aqui",
  "terr.task.champion": "derrotar o campeão",
  "terr.task.chest": "abrir o baú",
  "terr.locked": "{name} trancado · {what}",
  "terr.lockedLevel": "{name} trancado · precisa nível {n}",
  "terr.lockedHere": "{name} trancado · {what} em {here}",
  "terr.lockedChain": "{name} trancado · conquiste um território vizinho primeiro",
  "terr.mission": "Missão",
  "terr.conquered": "Conquistado — portas abertas",
  "terr.needLevelShort": "precisa Nv {n}",
  "terr.neighborFirst": "conquiste um vizinho primeiro",
  "terr.mtask.hunt": "abater {p}/{t}",
  "terr.mtask.champion": "derrotar o campeão",
  "terr.mtask.chest": "abrir o baú",
  "world.goals": "Missões da área",
  "world.goalsOpen": "abre o Portal Rift → {name} (Nv {n}+)",
  "world.goalsDepth": "fecha a volta → Profundidade {n}",
  "map.nextStep": "Próximo passo:",
  "map.anywhere": "qualquer monstro da área conta",
  "map.explore": "explorar",
  "map.tapGoal": "Toque numa missão acima pra ver no mapa onde fazer ela, ou num território pra ver os detalhes.",
  "map.focus.territories": "🧭 Visite mais {n} território(s) novo(s) pra fechar — os acesos no mapa ainda não contaram nesta volta. Basta entrar em cada um; voltar num que já contou não soma de novo.",
  "map.focus.champions": "👑 Campeões ainda vivos em {n} território(s) — os pontos rosa grandes.",
  "map.focus.chests": "📦 Baús fechados em {n} território(s) — os baús dourados no mapa (o número = quantos juntos). Nos ??? o selo só avisa que tem baú: explore pra achar onde.",
  "map.boss.lockAlpha": "derrote {have}/{need} elites pra abrir o Covil do Apex Fang",
  "map.boss.lockColossus": "derrote {have}/{need} Shard Wardens e explore as Terras pra abrir o portão do Colossus",
  "map.tab.lockGoals": "missões de {area} {done}/{total}",
  "map.bosses": "Bosses",
  "map.focus.kills": "⚔ Qualquer monstro da área conta. Os territórios abertos estão acesos.",
  "map.focus.boss": "💀 {name} está aqui (aceso no mapa).",
  "map.focus.bossSleep": "💤 O Guardião da área ainda dorme — acorda com {have}/{need} abates nesta área.",
  "map.focus.bossUnknown": "💀 O boss desta área ainda não apareceu no mapa.",
  "map.focus.none": "Nada disso visível agora — explore os ??? vizinhos (contorno tracejado).",
  "map.focus.nearest": "Mais perto: {name} (~{m} m)",
  "map.focus.clear": "limpar",
  "world.goalsDone": "área completa — Portal Rift liberado",
  "terr.champion": "Campeão",
  "terr.title": "MAPA DA REGIÃO",
  "terr.spires": "Agulhas",
  "terr.quarry": "Pedreira",
  "terr.hollow": "Cavidade",
  "terr.lowreach": "Baixada",
  "terr.saltflat": "Salina",
  "terr.geode": "Geodo",
  "terr.deepvein": "Veio Profundo",
  "terr.skyshelf": "Prateleira Celeste",
  "terr.updraft": "Corrente Ascendente",
  "terr.boneyard": "Cemitério de Pedra",
  "terr.gale": "Vendaval",
  "terr.arcfield": "Campo de Arcos",
  "terr.spiredge": "Beira da Agulha",
  "terr.stillwind": "Vento Parado",
  "terr.pillars": "Pilares",
  "terr.thunderpit": "Poço do Trovão",
  "terr.highroost": "Poleiro Alto",
  "terr.shroud": "Mortalha",
  "terr.stormeye": "Olho da Tempestade",
  "terr.lastledge": "Última Cornija",
  "terr.apex": "Cume",
  "terr.legend": "Arraste o mapa · toque num território para ver a gangue",
  "terr.unknown": "Território não explorado — vá até lá para revelar",
  "terr.unknownNear": "Território não explorado, vizinho de {name}.",
  "terr.unknownLevel": "Pede Nv {n} pra conquistar.",
  "terr.unknownGo": "Já dá pra ir — ande até lá pra revelar.",
  "terr.ravine": "Ravina Esquecida",
  "terr.crest": "Crista do Void",
  "terr.shardfield": "Campo de Lascas",
  "terr.grove": "Bosque Corrompido",
  "terr.den": "Covil do Alfa",
  "terr.fangtrail": "Trilha das Presas",
  "terr.whisper": "Mata Sussurrante",
  "terr.clearing": "Clareira do Void",
  "terr.garden": "Jardim de Cristais",
  "terr.marsh": "Alagado Pálido",
  "terr.entrance": "Entrada da Floresta",
  "terr.hills": "Colinas Baixas",
  "terr.roots": "Raízes Antigas",
  "terr.sleepgate": "Portal Adormecido",
  "terr.southmist": "Névoa do Sul",
  "terr.vein": "Veio Fraturado",
  "terr.wardens": "Terras do Guardião",
  "terr.mesa": "Mesa Estilhaçada",
  "terr.cliffs": "Penhascos do Aether",
  "terr.flats": "Planície de Cristal",
  "terr.glint": "Encosta Cintilante",
  "terr.shardpit": "Cova dos Shards",
  "terr.brokenpass": "Passo Quebrado",
  "terr.fissures": "Campo de Fissuras",
  "terr.thunder": "Cume Trovejante",
  "terr.crown": "Coroa da Tempestade",
  "terr.gorge": "Desfiladeiro Elétrico",
  "terr.overlook": "Mirante das Nuvens",
  "terr.windward": "Caminho do Vento",
  "terr.terrace": "Terraço da Ruína",

  // 10.5U — TUTORIAL contextual (aparece uma vez, na hora certa)
  "tip.move": "Use o direcional para andar — o ataque é automático. Fique de olho na barra de vida.",
  "tip.leaveBase": "Você saiu do anel da base: aqui os monstros atacam. Volte para o anel para se curar.",
  "tip.chain": "As armas da bolsa ficam presas por correntes e atacam sozinhas — até 3 ao mesmo tempo (4 com VIP), além da que está na sua mão.",
  "tip.levelup": "Você ganhou um Ponto do Void: gaste na Árvore (✦) para evoluir dano, defesa e mais.",
  "tip.elite": "Elites lideram a gangue do território: dão mais Fragmentos e loot melhor.",
  "tip.mission": "Missões dão Fragmentos e XP. A atual aparece no topo da tela.",
  "tip.altar": "O Altar do Void troca essência por atributos permanentes.",
  "tip.map": "Arraste o mapa para explorar. Cada território tem uma gangue diferente.",
  "tip.shop": "Você já tem Fragmentos: a Loja (🛒) vende vida, poder, pontos da Árvore e caçadas.",
  "tip.territory": "Território novo! Cada pedaço do mapa tem seus monstros e seu campeão.",
  "tip.death": "Ao morrer você volta para a base com 30% de vida e perde UM item da bolsa — nunca o equipado, nunca moedas ou XP.",

  // 10.5W — backup do progresso
  "settings.stickSide": "Direcional",
  "settings.stickRight": "à direita",
  "settings.stickLeft": "à esquerda",
  // 10.6C — distância da câmera
  "settings.camera": "Câmera",
  "settings.cam0": "Perto",
  "settings.cam1": "Padrão",
  "settings.cam2": "Longe",
  "settings.cam3": "Panorâmica",
  "backup.title": "Backup do progresso",
  "backup.hint": "Gere um código, guarde-o (WhatsApp/Notas) e cole em outro aparelho para continuar de onde parou.",
  "backup.placeholder": "cole aqui o código do backup",
  "backup.export": "Gerar e copiar",
  "backup.import": "Restaurar",
  "backup.copied": "Código gerado e copiado — guarde em lugar seguro.",
  "backup.restored": "Progresso restaurado! Reiniciando...",
  "backup.invalid": "Código inválido. Confira se copiou inteiro.",

  "world.tooLow": "Perigoso demais: volte no nível {n}",
  "world.title": "REGIÕES",
  "world.close": "Fechar",
  "world.travel": "Viajar",
  "world.here": "Você está aqui",
  "world.locked": "Bloqueada",
  "world.complete": "Concluída",
  "world.inProgress": "Em progresso",
  "world.tier": "Tier {n}",
  "world.recLevel": "Nv {n}+",
  "world.mastery": "Maestria {n}/{max}",
  "world.riftSurge": "Rift Surge",
  "world.masteryBtn": "Maestria",
  "world.surgeMax": "Surge {n} pronto",
  "world.surgeActive": "Surge {n} ATIVO",

  // Regional Mastery
  "mastery.title": "MAESTRIA DA REGIÃO",
  "mastery.lv": "Nv {n}",
  "mastery.maxed": "DOMINADA",
  "regionMastery.levelUp": "Maestria de {region} {n}",
  "mastery.masteredBanner": "{region} — REGIÃO DOMINADA",
  "mastery.reward.essence": "Reserva de essência",
  "mastery.reward.chest": "Baú regional",
  "mastery.reward.loot": "+ Chance de loot na região",
  "mastery.reward.surge2": "Rift Surge II desbloqueado",
  "mastery.reward.surge3": "Rift Surge III desbloqueado",
  "mastery.reward.title": "Título (em breve)",
  "mastery.reward.mastered": "REGIÃO DOMINADA",

  // Rift Surge
  "surge.title": "RIFT SURGE",
  "surge.normal": "Região Normal",
  "surge.normalDesc": "Dificuldade e recompensas padrão.",
  "surge.tierName": "Surge {n}",
  "surge.select": "Selecionar",
  "surge.on": "Ativo",
  "surge.activate": "Ativar",
  "surge.locked": "Bloqueado",
  "surge.desc1": "Inimigos mais duros · +maestria, loot e essência.",
  "surge.desc2": "Bem mais duro · mais elites · recompensas maiores.",
  "surge.desc3": "Brutal · elites frequentes · melhores recompensas.",
  "surge.objective": "Objetivo: derrote {kills} inimigos incl. {elites} elite(s)",
  "surge.hud": "Abates {k}/{nk} · Elites {e}/{ne}",
  "surge.doneShort": "OBJETIVO COMPLETO",
  "surge.activated": "RIFT SURGE {n} ATIVO",
  "surge.ended": "Rift Surge encerrado",
  "surge.complete": "RIFT SURGE COMPLETO",

  "attack.stoneSweep": "Golpe de Pedra",
  "attack.fractureCharge": "Investida Fraturante",
  "attack.shardRain": "Chuva de Estilhaços",
  "attack.corePulse": "Pulso do Núcleo",
  "attack.fractureLeap": "Salto Fraturante",
  "attack.prismaticLine": "Linha Prismática",
  "attack.coreOverload": "Sobrecarga do Núcleo",

  "weapon.colossusEdge": "Lâmina do Colosso",
  "weapon.aetherLongbow": "Arco Longo de Aether",
  "loot.colossusChest": "Baú do Colosso",
  "chest.colossus": "Baú do Colosso (até mítico)",

  // 10.6R — Correio + Diamantes + VIP
  "mail.title": "Correio",
  "mail.empty": "Sem mensagens",
  "mail.claim": "Coletar",
  "mail.claimed": "Coletado",
  "mail.interact": "Correio",
  "mail.welcome.title": "Bem-vindo, Caçador!",
  "mail.welcome.body": "Bem-vindo ao Void! Aqui vai um presente inicial para ajudar na sua jornada.",
  "mail.daily.title": "Bônus Diário",
  "mail.daily.body": "Dia {day} da sequência! Volte amanhã pra continuar subindo (some se pular um dia).",
  "mail.boss.voidAlpha.title": "Apex Fang Derrotado!",
  "mail.boss.voidAlpha.body": "Parabéns por derrotar o Apex Fang! Uma recompensa em Fragmentos espera por você.",
  "mail.boss.aetherColossus.title": "Aether Colossus Derrotado!",
  "mail.boss.aetherColossus.body": "O Colosso caiu! Colete sua recompensa em Fragmentos.",
  "mail.depth.title": "Marco de Profundidade!",
  "mail.depth.body": "Você alcançou a Profundidade {depth}! Aqui está sua recompensa.",
  "mail.newMail": "Novo correio!",
  "mail.season.title": "Prêmio da Temporada {season}!",
  "mail.season.body": "Você terminou em {rank}º em {category} na Temporada {season}. Parabéns, Caçador!",
  "currency.diamonds": "Diamantes",
  "vip.title": "Áreas VIP",
  "vip.shopTitle": "Loja VIP",
  "vip.unlock": "Desbloquear ({cost} 💎)",
  "vip.unlocked": "Desbloqueado",
  "vip.acquired": "Adquirido",
  "vip.locked": "Bloqueado",
  "vip.notEnough": "Diamantes insuficientes",
  "vip.noCoins": "Fragmentos insuficientes",
  "vip.noTier": "Sem VIP",
  "vip.needsPrev": "Precisa do {tier} primeiro",
  "vip.buyTier": "Adquirir ({cost} 💎)",
  "vip.tierUp": "{tier} desbloqueado!",
  "vip.tier.bronze": "VIP Bronze",
  "vip.tier.silver": "VIP Prata",
  "vip.tier.gold": "VIP Ouro",
  // 10.9EJ — bonus ativos no HUD
  "buff.spell": "Magia de bônus ativa",
  "buff.xp": "Bônus de XP",
  "buff.coin": "Bônus de moedas",
  "buff.luck": "Sorte: itens mais raros",
  "buff.contract": "Contrato: +75% de Fragmentos e essência",
  "buff.event": "Invasão do Vazio: dano e defesa acumulados",
  "buff.bless": "Bênçãos: ao morrer, revive no lugar sem anúncio — ou, se renascer na base, protege a Bolsa (gasta 1)",
  "buff.vip": "VIP ativo",
  "map.gateOpen": "Porta aberta", // 10.9EL
  "map.gateLocked": "Trancada", // 10.9EL
  // 10.9EO — RAID (boss mundial)
  "boss.raidTitan": "Titã do Eclipse",
  "raid.title": "Raid",
  "raid.soon": "⚔️ Raid do Titã em {t}",
  "raid.openLobby": "⚔️ RAID ABERTA · Titã acorda em {t} · Entrar",
  "raid.openLive": "⚔️ RAID AO VIVO · Entrar",
  "raid.entering": "⚔️ Entrando na Raid do Titã do Eclipse...",
  "raid.noCloud": "Raid indisponível: sem conexão com a conta na nuvem.",
  "raid.lost": "Raid: {why}. Voltando pro seu jogo.",
  "raid.unverified": "Seu perfil ainda não está na nuvem: seu dano conta com teto de segurança.",
  "raid.win": "🏆 TITÃ DERROTADO! Você ficou em {rank}º de {n}",
  "raid.fail": "⌛ O tempo acabou — o Titã resistiu.",
  "raid.backLater": "🌑 O Titã renasce em {t} — volte pelo botão RAID AO VIVO",
  "raid.leaveBtn": "Sair",
  "hud.stackShow": "Mostrar missões e bônus",
  "hud.stackHide": "Recolher",
  "raid.down": "Você caiu! Voltando em {s}s...",
  "raid.online": "na raid",
  "raid.wakes": "acorda em {t}",
  "raid.topDmg": "Mais dano",
  "raid.topTaken": "Levou mais dano",
  "raid.unique": "🌟 Item ÚNICO do Titã!",
  "raid.respawnIn": "🌑 O Titã renasce em {t}",
  "raid.myDmg": "Seu dano",
  "raid.victory": "TITÃ DERROTADO",
  "raid.timeUp": "TEMPO ESGOTADO",
  "raid.yourRank": "Você: {rank}º de {n}",
  "raid.suspect": "Parte do seu dano foi recusada pelo servidor (acima do possível pro seu personagem).",
  "raid.reward": "🎁 Raid: +{xp} XP · +{coins} 🪙 · +{dia} 💎",
  // 10.9EQ — ROUBO DE VIDA
  "equipment.attr.maxHpPct": "Vida %",
  "equipment.attr.damagePct": "Dano %",
  "equipment.attr.lifesteal": "Roubo de Vida",
  "attr.lifesteal": "ROUBO",
  "treeeffect.lifeStealPct": "Roubo de Vida",
  "stat.lifeSteal": "Roubo de Vida",
  "node.sur_leech": "Sede de Sangue",
  "node.sur_leech.d": "Cada golpe seu devolve +1% do dano causado como vida, por rank (ataque, flechas, Corrente e magias).",
  "node.sur_vampire": "Pacto Vampírico",
  "node.sur_vampire.d": "+1,5% do dano causado volta como vida, por rank. Soma com a Sede de Sangue e com o equipamento.",
  // 10.9ER — AJUDA DOS ATRIBUTOS (tocar no atributo)
  "attrhelp.hint": "Toque em um atributo pra ver o que ele faz",
  "attrhelp.dpsTotal": "Dano por segundo TOTAL: o que você tira da vida dos monstros a cada segundo, somando seus golpes e as armas da Corrente.",
  "attrhelp.moveSpeed": "Velocidade que o Caçador anda. Mais rápido = desvia dos golpes e chega antes nos monstros.",
  "attrhelp.maxHp": "Quanta vida você tem. Se chegar a zero, você cai e volta na base.",
  "attrhelp.regen": "Vida que volta sozinha a cada segundo. Se você tomou dano nos últimos 4 segundos, cura pela metade.",
  "attrhelp.lifeSteal": "Parte do dano que VOCÊ causa volta como vida (golpes, flechas, Corrente e magias). Cura no máximo 4% da vida por segundo.",
  "attrhelp.armor": "Reduz o dano que você recebe de qualquer golpe. O valor ao lado mostra quanto diminui de verdade.",
  "attrhelp.damage": "Dano de cada golpe seu, antes do crítico e dos bônus.",
  "attrhelp.dps": "Dano por segundo dos seus golpes (sem a Corrente), já contando velocidade de ataque e crítico.",
  "attrhelp.attackSpeed": "Quantos golpes você dá por segundo.",
  "attrhelp.attackRange": "Até onde o seu golpe alcança. Arcos e cajados vão mais longe que espadas.",
  "attrhelp.critChance": "Chance de cada golpe ser CRÍTICO, que bate mais forte.",
  "attrhelp.critDamage": "Quanto o golpe crítico bate. 150% = o crítico causa uma vez e meia o dano normal.",
  "attrhelp.dmgSlash": "Dano extra com golpes CORTANTES (espadas e machados).",
  "attrhelp.dmgPierce": "Dano extra com golpes PERFURANTES (arcos).",
  "attrhelp.dmgBlunt": "Dano extra com golpes CONTUNDENTES (clavas).",
  "attrhelp.vsElite": "Dano extra contra Elites, Campeões e Bosses.",
  "attrhelp.execute": "Dano extra contra monstros com menos de 30% de vida — termina a luta mais rápido.",
  "attrhelp.resilience": "Reduz TODO o dano que você recebe, de qualquer tipo, depois da armadura.",
  "attrhelp.defSlash": "Reduz o dano CORTANTE que você recebe.",
  "attrhelp.defPierce": "Reduz o dano PERFURANTE que você recebe (flechas e espinhos).",
  "attrhelp.defBlunt": "Reduz o dano CONTUNDENTE que você recebe (pancadas).",
  "attrhelp.block": "Chance de BLOQUEAR um golpe: você toma só metade do dano e é menos empurrado.",
  "attrhelp.hookRange": "Até onde o Gancho alcança para puxar um monstro.",
  "attrhelp.hookCooldown": "Tempo de espera pra usar o Gancho de novo.",
  "attrhelp.sprintDuration": "Quanto tempo dura a Corrida (botão »).",
  "attrhelp.sprintCooldown": "Tempo de espera pra correr de novo.",
  "attrhelp.chainCount": "Quantas armas da Bolsa ficam presas na Corrente, girando em volta de você e atacando sozinhas.",
  "attrhelp.chainDps": "Dano por segundo somado das armas da Corrente.",
  "attrhelp.chainReach": "Até onde as armas da Corrente alcançam os monstros.",
  // 10.9ES — NOVIDADES da atualizacao
  "update.title": "Novidades",
  "update.reward": "Presente desta atualização: ",
  "update.claim": "Resgatar e jogar",
  "update.ok": "Jogar",
  "update.got": "🎁 +{coins} 🪙 · +{dia} 💎",
  "training.confirm": "Confirmar: {what}?", // 10.9ET
  // 10.9EV
  "attr.bought": "comprado",
  "attr.boughtN": "comprado {n}×",
  "shop.confirmBuy": "Comprar {name} por {price}?", // 10.9EJ
  "vip.confirmTitle": "Confirmar compra",
  "vip.confirmPack": "Comprar {diamonds} 💎 por {price}?",
  "vip.confirmPackFirst": "Comprar {diamonds} 💎 (1ª compra em DOBRO) por {price}?",
  "vip.confirmPackFirstPct": "Comprar {diamonds} 💎 (1ª compra +{pct}%) por {price}?",
  "vip.confirmPass": "Ativar o Passe VIP por {days} dias ({price}) e receber +{diamonds} 💎?",
  "vip.confirmTestNote": "Modo teste: nenhuma cobrança real é feita.",
  "vip.confirmYes": "Confirmar",
  "vip.confirmNo": "Cancelar",
  "vip.tier.platinum": "VIP Platina",
  "vip.tier.diamond": "VIP Diamante",
  "vip.tier.master": "VIP Mestre",
  "vip.points": "{n} pontos VIP",
  "vip.pointsNext": "{n} → {tier}",
  "vip.pointsMax": "Tier máximo!",
  "vip.pointsReq": "{n} pontos VIP",
  "vip.pointsMissing": "Faltam {n} pontos VIP",
  "vip.pointsHint": "Cada 💎 gasto no jogo vira 1 ponto VIP — vale igual pro 💎 ganho jogando e pro comprado. O tier sobe sozinho.",
  "vip.perk.xp": "+{pct}% XP em tudo",
  "vip.perk.coins": "+{pct}% Fragmentos",
  "vip.perk.essence": "+{pct}% Essência coletada",
  "vip.perk.absorb": "+{pct}% Absorção (vida/dano)",
  "vip.perk.bagBonus": "+{n} espaços de bolsa (bônus do tier)",
  "vip.perk.weaponSlot": "+1 slot de arma na corrente (mais uma arma atacando)",
  "vip.perk.dropBoost": "Drop de raridade melhorado",
  "vip.perk.dailyDiamonds": "+{n} 💎 bônus diário no correio",
  "vip.perk.areas": "{n} áreas VIP: XP bônus na região (Floresta ×1,5 · Terras ×1,8 · Tempestade ×2,0)",
  "vip.packsTitle": "Pacotes de Diamantes",
  "vip.packsHint": "💎 é moeda premium. Os pacotes ainda não estão à venda. Enquanto isso, 💎 vem de jogar: login diário, missão diária, Profundidade e anúncio.",
  "vip.firstPackHint": "🎁 Sua primeira compra vem com bônus extra — só essa vez.",
  "vip.packSoon": "Compra em breve — integração de pagamento pendente",
  "vip.testPurchase": "[TESTE] +{amount} 💎 creditados (sem cobrança)",
  "vip.testPurchaseFirst": "🎉 [TESTE] 1ª compra em DOBRO: +{amount} 💎 creditados (sem cobrança)",
  "vip.testPurchaseFirstPct": "🎉 [TESTE] 1ª compra +{pct}%: +{amount} 💎 creditados (sem cobrança)",
  "vip.pack.starter": "Pacote Inicial",
  "vip.pack.mini": "Pacote Mini",
  "vip.pack.small": "Pacote Pequeno",
  "vip.pack.medium": "Pacote Médio",
  "vip.pack.large": "Pacote Grande",
  "vip.pack.mega": "Pacote Mega",
  "vip.pack.ultimate": "Pacote Supremo",
  "vip.pack.legend": "Pacote Lendário",
  "vip.pack.tag.popular": "POPULAR",
  "vip.pack.tag.best": "MELHOR VALOR",
  "vip.pack.bonusLabel": "BÔNUS",
  "vip.pack.firstDouble": "1ª compra ×2",
  "vip.pack.firstPct": "1ª compra +{pct}%",
  "vip.crystallineHollow": "Caverna Cristalina",
  "vip.crystallineHollow.desc": "Cristais raros e monstros mais fortes na Floresta Esquecida. Loot e XP aumentados.",
  "vip.aetherSanctum": "Santuário de Aether",
  "vip.aetherSanctum.desc": "Zona secreta nas Terras Fraturadas. Inimigos de elite e drops exclusivos.",
  "vip.stormNexus": "Nexus da Tempestade",
  "vip.stormNexus.desc": "O coração da tempestade. Desafio máximo com as melhores recompensas do jogo.",
  "vip.areaUnlocked": "Área VIP desbloqueada!",
  "vip.region": "Região: {region}",
  "vip.bonus": "XP ×{mult} · Loot melhorado",
  "mail.claimAll": "Coletar tudo",
  "mail.allClaimed": "Tudo coletado!",
  "mail.levelUp.title": "Subiu de Nível!",
  "mail.levelUp.body": "Parabéns por alcançar o nível {level}! Aqui está um presente.",
  "mail.vipDaily.title": "Bônus VIP Diário",
  "mail.vipDaily.body": "Recompensa exclusiva do seu plano VIP. Obrigado por ser VIP!",
  "dshop.title": "Gastar Diamantes",
  "dshop.vipDiscount": "VIP: -{pct}% de desconto em tudo",
  "dshop.alreadyOwned": "Você já tem esta roupa",
  "dshop.outfitUnlocked": "Roupa desbloqueada! Vá até a Guarda-roupa",
  "dshop.noWeapon": "Equipe uma arma primeiro",
  "dshop.chestRare": "Baú Cristal",
  "dshop.chestEpic": "Baú Aether",
  "dshop.chestLegend": "Baú Lendário",
  "dshop.chestMythic": "Baú Mítico 🏆",
  "dshop.bossWeapon": "Arma de Boss Lendária",
  "dshop.bossWeaponGot": "Arma de Boss Lendária obtida!",
  "dshop.noBossWeapon": "Nenhuma arma de boss disponível",
  "dshop.coinPack": "+2000 Fragmentos",
  "dshop.shardPack": "+20 Shards p/ arma",
  "dshop.bagSlots": "🎒 Mochila +10 espaços",
  "dshop.bagMax": "Mochila já está no máximo ({max} espaços)",
  "dshop.bagFull": "MÁX",
  "dshop.bagBought": "Mochila: {n}/{max} espaços",
  "dshop.boostXp": "2× XP · 30 min",
  "dshop.boostCoin": "2× Moedas · 30 min",
  "dshop.boostLuck": "Sorte · drop melhor · 30 min",
  "dshop.boostCombo": "2× XP + Moedas · 60 min",
  "dshop.elixir3": "🧪 Elixir de Proteção ×3",
  "dshop.elixir10": "⚗️ Elixir de Proteção ×10",
  "dshop.elixirGot": "+{n} Elixir de Proteção",
  "dshop.bless1": "🕊️ Bênção ×1",
  "dshop.bless5": "🕊️ Bênção ×5",
  "dshop.blessGot": "+{n} Bênção",
  "bless.saved": "🕊️ A Bênção te protegeu — nenhum item perdido! (restam {n})",
  "bless.lost": "☠️ Sem Bênção: você perdeu {item} da bolsa!",
  "bless.revive": "🕊️ Reviver aqui com Bênção (sem anúncio · {n})",
  "bless.revived": "🕊️ A Bênção te reviveu aqui! (restam {n})",
  "dshop.outfitGold": "Roupa Dourada VIP",
  "dshop.outfitObsidian": "Roupa Obsidiana",
  "dshop.outfitRoyal": "Roupa Realeza",
  "vip.passTitle": "Passe VIP (30 dias)",
  "vip.passName": "Passe VIP Ativo",
  "vip.passNameOff": "Passe VIP",
  "vip.passDuration": "Dura {days} dias · Bônus exclusivos multiplicativos",
  "vip.passRemaining": "Ativo · {days} dias restantes",
  "vip.passBuy": "Ativar Passe · {cost}",
  "vip.passRenew": "Renovar +30 dias · {cost}",
  "vip.passActivated": "Passe VIP ativado por {days} dias!",
  "vip.passActivatedBonus": "Passe VIP ativado por {days} dias! +{diamonds} 💎 de bônus creditados.",
  "vip.passOutfitGot": "Roupa exclusiva {name} liberada no Guarda-Roupa!",
  "vip.pass.bonusDiamonds": "Bônus de diamantes na ativação",
  "vip.pass.xp": "XP em cima de TUDO (multiplica outros bônus)",
  "vip.pass.coin": "Fragmentos em cima de tudo",
  "vip.pass.daily": "Diamantes bônus por dia no correio",
  "vip.pass.weaponSlot": "Slot de arma VIP: +1 arma atacando na corrente",
  "vip.pass.outfit": "Roupa exclusiva {name} — sua pra sempre",
  "attr.shopTitle": "Comprar Atributos (Permanentes)",
  "attr.shopHint": "Melhoram seu personagem PERMANENTEMENTE — cada compra sente na hora. E fica: a Ameaça Crescente não enxerga o que você compra aqui, então essa vantagem nunca é alcançada pelos monstros conforme você avança.",
  "attr.hp.small": "Vida Menor",
  "attr.hp.med": "Vida Média",
  "attr.hp.big": "Vida Máxima",
  "attr.hp.mega": "Vida Suprema",
  "attr.dmg.small": "Dano Menor",
  "attr.dmg.med": "Dano Médio",
  "attr.dmg.big": "Dano Máximo",
  "attr.dmg.mega": "Dano Supremo",
  "attr.regen.small": "Regen Menor",
  "attr.regen.med": "Regen Média",
  "attr.regen.big": "Regen Máxima",
  "attr.regen.mega": "Regen Suprema",
  "mail.markAllRead": "Marcar lidas",
  "mail.deleteRead": "Apagar lidas",
  "inventory.needLevel": "Precisa nível {n} para equipar",
  "inventory.autoEquipped": "Equipado: {name}",
  "forge.title": "Forja",
  "forge.hint": "Suba o NÍVEL de qualquer equipamento (1→250) gastando SHARDS ✨ e FRAGMENTOS 🪙 (custo sobe com nível e raridade). Acima do nível seguro há CHANCE DE QUEBRA (cai 1 nível) — o 🧪 Elixir de Proteção impede a queda.",
  "forge.noCoins": "Fragmentos insuficientes (precisa de {n} 🪙)",
  "forge.empty": "Nenhum equipamento na bolsa. Mate monstros e abra baús pra pegar itens.",
  "forge.upgradeTo": "Forjar → L{n}",
  "forge.max": "Máximo",
  "forge.safe": "seguro",
  "forge.risk": "⚠ {p}% quebrar",
  "forge.protected": "🧪 {p}% (protegido)",
  "forge.protect": "Proteger com elixir",
  "forge.elixirsHave": "Elixires: {n}",
  "forge.noElixir": "Sem elixir (a loja de 💎 vende proteção)",
  "forge.up": "Forjado! Nível {n}",
  "forge.saved": "🧪 Elixir salvou! Nível {n}",
  "forge.broke": "💥 Quebrou — caiu pro nível {n}",
  "forge.noShards": "Shards insuficientes",
  "wardrobe.short": "Roupa",
  "class.title": "Escolha sua Classe",
  "class.charsTitle": "Seus Personagens",
  "class.sub": "Cada classe é um personagem com progresso próprio (nível, árvore, itens).",
  "class.choose": "Escolher",
  "class.play": "Jogar",
  "class.create": "Criar personagem",
  "class.nameTitle": "Nomeie seu {cls}",
  "class.nameSub": "Escolha um nome (ou toque numa sugestão). Não pode repetir outro personagem.",
  "class.namePlaceholder": "Nome do personagem",
  "class.nameConfirm": "Criar",
  "class.nameTooShort": "Nome muito curto (mín. 2 letras).",
  "class.nameTaken": "Você já tem um personagem com esse nome.",
  "inventory.unequippedLevel": "{n} item(ns) acima do seu nível voltaram pra bolsa.",
  "voidTree.rebalanced": "✦ Árvore do Void rebalanceada: agora é 1 ponto a cada 2 níveis. Seus pontos foram devolvidos — redistribua!",
  "class.wrongWeapon": "Essa arma não é da sua classe",
  "class.delete": "Excluir",
  "class.deleteConfirm": "Excluir o {name}? Todo o progresso desse personagem some pra sempre.",
  "class.warrior.name": "Guerreiro",
  "class.warrior.desc": "Tanque corpo a corpo: muita vida e armadura, dano sólido.",
  "class.archer.name": "Arqueiro",
  "class.archer.desc": "Ágil à distância: ataque rápido e crítico, menos vida.",
  "class.mage.name": "Mago",
  "class.mage.desc": "Vidro-canhão: dano mágico altíssimo, mas frágil.",
  "class.necromancer.name": "Necromante",
  "class.necromancer.desc": "Invoca servos que caçam e batem nos monstros. Castiga de longe com o cajado.",
  "sell.title": "Vender",
  "sell.hint": "Toque nos itens pra marcar e venda vários de uma vez por 🪙. A auto-venda transforma drops até a raridade escolhida em moeda na hora (equipados nunca são vendidos).",
  "sell.auto": "Auto-vender até:",
  "sell.off": "Desligado",
  "sell.markLow": "Marcar comuns/incomuns",
  "sell.clear": "Limpar",
  "sell.empty": "Bolsa vazia. Mate monstros e abra baús pra pegar itens.",
  "sell.sellN": "Vender {n} · +{coins} 🪙",
  "sell.sold": "Vendeu {n} · +{coins} 🪙",
  "sell.autoSold": "Auto-venda +{coins} 🪙",
  "boss.challenge": "Desafiar Boss",
  "test.interact": "🔥 Arena de Teste (1 de cada monstro)",
  "test.spawned": "Arena de Teste: {n} monstros invocados!",

  // 10.9BY — Skills + Treino
  "skills.title": "🎯 Skills",
  "skills.sword": "Espada",
  "skills.axe": "Machado",
  "skills.mace": "Maça",
  "skills.ranged": "Distância",
  "skills.magic": "Magia",
  "skills.summon": "Invocação",
  "skills.defense": "Defesa",
  "skills.inUse": "em uso",
  "skills.max": "MÁXIMO",
  "skills.bonusWeapon": "+{dmg}% dano · +{spd}% vel.",
  "skills.bonusDefense": "-{n}% dano recebido",
  "skills.levelUp": "{icon} {name} nível {n}!",
  "skills.hint": "Skills sobem lutando (golpes, abates, bosses; Defesa ao tomar dano) e no Boneco de Treino do Santuário (offline, por tempo real: 🪙/h ou 💎).",
  "source.skills": "Skills",
  "training.interact": "🎯 Boneco de Treino",
  "training.train": "Treinar {name}",
  "training.training": "Treinando {name}",
  "training.left": "faltam {time}",
  "training.done": "concluído!",
  "training.rate": "{n} XP/min",
  "training.pending": "{n} XP rendidos",
  "training.willGain": "Rende {n} XP",
  "training.perHour": "{n} 🪙/h",
  "training.payCoins": "Treinar · {n} 🪙",
  "training.payDiamonds": "Pagar com {n} 💎",
  "training.collect": "Coletar +{n} XP",
  "training.double": "📺 Dobrar",
  "training.doubleVip": "👑 Dobrar",
  "training.finishNow": "Terminar agora · {n} 💎",
  "training.started": "🎯 Treino de {name} iniciado ({h}h)",
  "training.collected": "🎯 +{n} XP em {name}",
  "training.finished": "Treino concluído — colete no Boneco de Treino",
  "training.busy": "Já existe um treino em andamento",
  "training.hud": "{time}",
  "training.hudDone": "pronto!",

  // 10.9IH - TUTORIAL GUIADO (tour) + manual "Como jogar"
  "guide.skip": "Pular",
  "guide.start": "Seguir o tutorial",
  "guide.next": "Próximo",
  "guide.finish": "Concluir",
  "guide.done": "✅ Tutorial concluído. O manual completo fica em Pausa → Como jogar.",
  "guide.welcome.t": "Bem-vindo ao Void",
  "guide.welcome.b": "Um passeio rápido pela tela, em menos de dois minutos. Dá pra pular agora ou no meio, e refazer depois em Pausa → Como jogar.",
  "guide.move.t": "Andar",
  "guide.move.b": "Arraste o direcional para mover o Caçador. Ande um pouco para continuar.",
  "guide.auto.t": "O ataque é automático",
  "guide.auto.b": "Você não aperta nada para atacar: o Caçador golpeia sozinho o inimigo mais próximo dentro do alcance da arma. O seu trabalho é escolher a posição e a hora de recuar.",
  "guide.life.t": "A sua vida",
  "guide.life.b": "A barra flutua acima do Caçador, para você não precisar tirar o olho dele. Ela fica vermelha abaixo de um terço.",
  "guide.base.t": "A base é segura",
  "guide.base.b": "Dentro do anel da base nenhum monstro entra e você recupera 8% da vida por segundo. Lá fora a cura cai para 0,7% por segundo, e só começa 8 segundos depois do último dano.",
  "guide.sprint.t": "Correr",
  "guide.sprint.b": "Dá 60% mais velocidade por 2 segundos, com 4 de recarga. Serve para sair de cerco: não é esquiva, você continua levando dano.",
  "guide.hook.t": "Gancho",
  "guide.hook.b": "Puxa o inimigo até você. É o único jeito de quem luta corpo a corpo alcançar quem voa, porque arma de mão não acerta inimigo voando.",
  "guide.potion.t": "Poção",
  "guide.potion.b": "Cura metade da vida na hora, com 8 segundos de recarga. Você compra na Loja e também encontra em baús.",
  "guide.gear.t": "Arma e correntes",
  "guide.gear.b": "O primeiro espaço é a arma na sua mão. Os outros são as correntes: armas da bolsa que flutuam e atacam sozinhas. Eles abrem nos níveis 10, 20 e 30.",
  "guide.status.t": "Nível, XP e moedas",
  "guide.status.b": "A cada 2 níveis você ganha 1 ponto da Árvore do Void. Logo abaixo ficam Essência, Fragmentos e Diamantes.",
  "guide.mission.t": "Missão atual",
  "guide.mission.b": "São 3 missões ao mesmo tempo, mais uma diária. A recompensa não cai sozinha: toque em Coletar quando terminar.",
  "guide.map.t": "Minimapa",
  "guide.map.b": "Mostra onde você está e o que já explorou. Toque para abrir o Mapa do Mundo, com os territórios e o que falta em cada um.",
  "guide.menu.t": "Os atalhos",
  "guide.menu.b": "Bolsa, Loja, Missões, Correio e VIP. A forja, a venda e o guarda-roupa ficam dentro da Bolsa.",
  "guide.mail.t": "Não esqueça o Correio",
  "guide.mail.b": "Todo dia tem uma recompensa te esperando aqui — e ela cresce se você voltar dia após dia. Pular um dia reseta a sequência.",
  "guide.more.t": "Ajustes e manual",
  "guide.more.b": "A engrenagem abre qualidade gráfica, idioma e controles. O manual completo, com forja, Ameaça, bosses e Árvore, fica em Pausa → Como jogar.",
  "htp.title": "Como jogar",
  "htp.sub": "Cada parte do jogo, explicada. Toque numa seção para abrir.",
  "htp.replay": "Refazer o tutorial guiado",
  "htp.combat.t": "Combate",
  "htp.combat.b": "O ataque é automático: o Caçador golpeia sozinho o inimigo mais próximo dentro do alcance da arma. Ele escolhe alvo num raio de 9 metros e só larga quando o bicho passa de 11,5.\nNão existe esquiva. Correr dá 60% de velocidade por 2 segundos e serve para se reposicionar, não para ficar imune.\nArma corpo a corpo não acerta inimigo voando. Use arco ou cajado, ou traga o bicho ao chão com o Gancho.\nElite, campeão e boss tiram uma fatia da sua vida MÁXIMA que ignora armadura: 5%, 9% e 10% por golpe. E toda redução de dano para em 80%, então você sempre leva pelo menos um quinto do golpe.",
  "htp.base.t": "A base segura",
  "htp.base.b": "Dentro do anel, de 14 metros, você é invulnerável, os monstros desistem e você recupera 8% da vida por segundo.\nNo campo a regeneração é de 0,7% por segundo, e só começa 8 segundos depois do último dano.\nUm aviso marca as duas travessias: ZONA SEGURA ao entrar e ZONA DE COMBATE ao sair de vez.\nNa base ficam o Altar do Void ao norte, o correio, o portal de PvP, o boneco de treino e, no canto sudeste, o portal da Fenda dos Titãs.",
  "htp.chain.t": "Correntes de armas",
  "htp.chain.b": "Até 3 armas da bolsa (4 com VIP ou Passe VIP) flutuam ao seu redor e atacam sozinhas, com alcance de 5,5 metros. Elas acertam inimigos voadores.\nCada corrente bate por volta de 30% do que aquela arma bateria na sua mão. O jogo escolhe sozinho as de maior dano que a sua classe pode usar e o seu nível permite equipar.\nOs espaços abrem por nível: o segundo no 10, o terceiro no 20 e o quarto no 30; o quinto é o slot VIP. A mesma arma pode aparecer em raridades diferentes. Antes do nível 10 você não tem nenhuma corrente.",
  "htp.death.t": "Morrer",
  "htp.death.b": "Você volta para a base em 2 segundos, com 30% da vida e 2 segundos de proteção.\nA penalidade é UM item aleatório da bolsa. Nunca o que está equipado, nunca moedas, nunca XP, nunca nível. Bolsa vazia, nada se perde.\nUma Bênção se gasta no lugar do item. E reviver ali mesmo, por vídeo ou por VIP, cancela a penalidade inteira.\nFugir sai caro: fora de combate o monstro regenera 10% por segundo e volta ao cheio.",
  "htp.threat.t": "Ameaça: o mundo cresce com você",
  "htp.threat.b": "Todo monstro morto te melhora para sempre: parte da vida dele vira a sua vida máxima, e parte do dano dele vira o seu dano. É a Absorção.\nSó que os monstros escalam junto, sempre um passo atrás. Quanto mais vida efetiva você tem, mais forte eles batem. Quanto mais dano você dá, mais vida eles têm.\nNem tudo conta igual: só metade do que você absorveu dos abates e 40% do que vem do equipamento alimentam a Ameaça. Os outros 60% do que você forja são ganho líquido de verdade.\nExiste teto: um monstro nunca precisa de mais golpes seus do que o limite do tier dele, de 9 a 26, e um boss para em 60.\nNa prática, continuar evoluindo compensa — mas empilhar só vida e armadura rende menos do que parece, porque o jogo lê isso como vida efetiva e devolve em dano.",
  "htp.loot.t": "Itens, raridade e tiers",
  "htp.loot.b": "Raridades: comum, incomum, raro, épico, lendário e mítico. Cada degrau multiplica os atributos e dá mais um encanto, até 6 no mítico, e o comum agora vem com 1.\nCada item pede um nível para equipar: raro no 10, épico no 20, lendário no 35, mítico no 50. O TIER pede mais ainda: tier 2 no nível 20, tier 7 no 150, tier 10 no 300, tier 14 no nível 1000.\nO que cai é limitado ao que você já pode usar, então não adianta caçar mítico no nível 5. A primeira área nunca solta lendário.\nArma repetida (mesma arma e raridade de uma que você já tem) entra dentro dela: +1 na barra de evolução e ainda dá material de forja. Com 100 cópias ela sobe de raridade e mantém o nível de forja. Armadura repetida vira material de forja. Bolsa cheia não perde drop. A bolsa começa com 30 espaços e vai até 100 com diamantes.",
  "htp.forge.t": "Forja, quebra e venda",
  "htp.forge.b": "A forja leva qualquer item do nível 1 ao 250. Cada nível dá 9% de dano base na arma e 6% de armadura na roupa.\nAté o nível 15 não há risco nenhum. Acima disso a chance de quebrar sobe 0,4% por nível, com teto de 40%. Quebrar gasta o material e derruba o item um nível — nunca destrói.\nO Elixir de Proteção transforma a quebra em salvo. Ele é consumido em toda tentativa com risco, não só quando salva.\nVender só funciona com item da bolsa; o que está equipado é ignorado. O preço sobe 12% por nível de forja.",
  "htp.money.t": "As moedas",
  "htp.money.b": "Fragmentos vêm de abates, baús, missões e vendas. Compram poção, cura, material, Contrato de Caça, vida e poder na Loja. O preço sobe a cada compra.\nEssência cai dos monstros em orbes e só serve no Altar do Void, para atributos permanentes. O custo sobe 35% a cada nível.\nMaterial de forja é POR ITEM: o de uma espada não serve em outra.\nDiamantes são premium, mas se ganham jogando: 5 por login diário, 3 por missão diária e 10 a cada 5 Profundidades. Boss e subir de nível não dão diamante.",
  "htp.tree.t": "Árvore do Void",
  "htp.tree.b": "Você ganha 1 ponto a cada 2 níveis, mais 1 pelo primeiro Apex Fang e 4 por Profundidade.\nSão quatro ramos: Poder, Sobrevivência, Agilidade e o da sua classe. Fechar tudo custa perto de 870 pontos, e cada ramo termina em nós infinitos de 50 degraus.\nDá para redistribuir por 10 diamantes; cada redistribuição deixa a próxima 1% mais cara.\nA Árvore abre pelo Altar do Void, na base.",
  "htp.classes.t": "Classes, magias e perícias",
  "htp.classes.b": "São quatro: Guerreiro, com muita vida, armadura e bloqueio; Arqueiro, rápido e com crítico; Mago, o maior dano e a menor vida; e Necromante.\nA classe decide a arma: guerreiro usa espada, machado e maça; arqueiro usa arco; mago e necromante usam cajado.\nToda classe tem 3 magias base e mais 3 que abrem nos níveis 10, 25 e 40. O Grimório, na pausa, escolhe quais 3 das 6 ficam nos botões.\nExistem duas evoluções paralelas ao nível: a Maestria de cada tipo de arma, que sobe batendo, e as 7 Perícias, que sobem no boneco de treino da base, inclusive com o jogo fechado.",
  "htp.world.t": "Territórios e Profundidade",
  "htp.world.b": "O mapa é dividido em territórios. Para abrir um você precisa de três coisas ao mesmo tempo: um vizinho já conquistado, o nível mínimo do tier dele e a missão local cumprida.\nA missão local é caçar de 20 a 76 monstros da gangue dali, mais o campeão e o baú, quando o território tem.\nPara trocar de região pelo Portal Rift, todas as metas da área precisam estar fechadas E você precisa do nível recomendado do destino.\nAlguns territórios das Terras Fraturadas e da Tempestade machucam sozinhos (brasa, gelo, vendaval e tempestade): você tem 2,5 s de aviso e depois perde 5,5% da vida por segundo, até pôr o anel certo no acessório. Os anéis ficam na Loja e equipam a partir do nível 16. Atenção, eles são cruzados: o Anel de Brasa protege do gelo, e o Anel de Geada protege da brasa. Tocar no aviso do alto da tela equipa o anel (se ele está na Bolsa) ou abre a Loja direto nele.\nFechar a última área sobe a Profundidade: os monstros ganham vida e dano, as metas crescem 50%, as recompensas sobem 60% — e o mapa inteiro TRANCA de novo, para ser reconquistado.",
  "htp.missions.t": "Missões",
  "htp.missions.b": "São 3 missões ativas o tempo todo, sem tempo e sem energia. Quando termina, a recompensa fica esperando: toque em Coletar.\nA diária é uma só por dia, sorteada pelo dia do calendário, e dá diamantes além de moedas e XP. Dia perdido não acumula.\nRepetir a mesma missão paga mais: cada repetição soma 30% na recompensa.",
  "htp.bosses.t": "Bosses",
  "htp.bosses.b": "Apex Fang, da primeira área: mate 3 elites para abrir a barreira, entre na arena e aceite o desafio.\nColosso de Éter, da segunda: precisa de 3 Shard Wardens mortos e das 4 sub-áreas descobertas.\nGuardião da região: os abates da região inteira carregam ele. Ao acordar, larga uma arma lendária garantida, e fica mais forte a cada vez que você o derruba.\nTodo boss entra em FÚRIA abaixo de 30% da vida. E todo boss é preso à arena: se você sair, a luta reinicia sem punição nenhuma.",
  "htp.endgame.t": "Fenda dos Titãs e fim de jogo",
  "htp.endgame.b": "O portal no canto sudeste da base leva à Fenda: 15 salas fora do mapa, cada uma com o seu titã. Entrar no portal não exige nada.\nAs portas exigem nível: a sala 1 no 10, a sala 5 no 45, a sala 10 no 100. As cinco últimas são de prestígio, nos níveis 200, 400, 600, 800 e 1000, e ainda pedem 25%, 50%, 70%, 90% e 100% da Árvore do Void fechada.\nA porta sela quando você aceita o desafio. Cada sala só vale de novo depois de 15 horas reais.\nA arma exclusiva do titã é rara: 1,5% de chance por abate.",
  // 10.9IT — painel de administracao: correio da equipe e conta suspensa
  "mail.admin.title": "Presente da administração",
  "mail.admin.body": "A equipe do VOID HUNTER enviou isto para você. {note}",
  "admin.grantBanner": "📬 Você recebeu {n} envio(s) da administração — veja o Correio",
  "admin.levelSet": "⭐ A administração definiu o seu nível: {n}",
  "admin.wiped": "🧹 A administração zerou esta conta. Recomeçando…",
  "admin.itemRemoved": "🗑️ A administração removeu um item da sua bolsa",
  "admin.itemLevelSet": "🔨 A administração ajustou a forja de um item: nível {n}",
  "admin.areaCompleted": "🗺️ A administração liberou a área: {name}",
  "ban.title": "Conta suspensa",
  "ban.body": "Esta conta foi suspensa pela administração do VOID HUNTER.",
  "ban.until": "Suspensa até {date}.",
  "ban.perm": "Suspensão sem prazo.",
};
